import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./MemberProfileModal.css";
// Le classi CONDIVISE che la scheda riusa invece di ridichiararle: pastiglia
// categoria §2 (.qpsc-pill), pulsanti §5.1/§5.3/§5.4 (.qpsc-tool-btn,
// .qpsc-ghost-btn, .qpsc-profile-btn). Il foglio contiene solo selettori di
// classe con prefisso `qpsc-`: importarlo non tocca nessun'altra pagina.
import "./AdminTools.css";
// ⚠️ QUESTO IMPORT NON SERVE A QUESTA PAGINA, e va spiegato o qualcuno lo
// toglierà per pulizia rompendo altre schermate.
// `EvaluationSheetModal.css` è un FOGLIO D'EREDITÀ GLOBALE: CRA lo emette nel
// bundle unico, e da lì vestono i TAG NUDI `input, select` di mezza app —
// compreso `select:valid`, che è ciò che produce il BORDO ORO delle tendine
// negli strumenti admin, deroga scritta e voluta (doc 07 §8, rev. 6/8/2026).
// Fino a oggi quel foglio entrava nel bundle per una via sola: l'import del
// componente `EvaluationSheetModal` fatto QUI. La fase 4a smette di aprire
// quella finestra (gruppo 8c: bottone spento, «coming soon»), e senza questa
// riga il foglio uscirebbe dal bundle IN SILENZIO — Team Assignment,
// EditMemberModal e le altre finestre non ricostruite cambierebbero resa per
// un intervento che non le nomina nemmeno.
// Il foglio si toglie nel cantiere di Evaluation, dove il §8 prescrive di
// REIMPIANTARE deliberatamente il bordo oro con una regola `qpsc-`. Non prima,
// e non da qui.
import "./EvaluationSheetModal.css";
import HomeShell from "./HomeShell";
import avatarPlaceholder from "../assets/avatar-placeholder.png";
import { api, API_ROOT, authHeaders } from "../api/api";
import AuthAvatar from "./AuthAvatar";
import Webcam from "react-webcam";
import { useAuth } from "../context/AuthContext";
import { canonicalRole, getActiveRoles, isEnrolled, normalizeRole, puoAgireSuBersaglio, roleLabel } from "../auth/access";
// ⚠️ `normalizza` NON si importa piu': l'unico chiamante era la categoria
// letta dal documento SQUADRA, che VP2/F1 ha sostituito con l'anagrafica.
import { hasRole } from "../utils/roleUtils";
// LA SEDE UNICA DELLA LETTURA DI SQUADRA (cantiere «lettore unico»): qui
// arrivano, gia' scritte, le quattro funzioni che questa scheda teneva in
// copia locale. `valeSuTutteLeSquadre` non si importa piu': la legge il
// modulo, dentro il ripiego di `squadreDellaTessera`.
import {
  squadreDellaTessera,
  squadreDelleTessere,
  statoDelleTessere,
  tessereDelSoggetto
} from "../utils/squadre";
// LA SEDE UNICA DELLE DIVISE (`utils/uniforms.js`): la lista dei capi, le
// etichette dei tre stati e il criterio di spettanza arrivano tutti da li'.
// ⚠️ DUE «FETTE B» OMONIME, da non confondere:
//  - la Fetta B del cantiere UNIFORMS (agosto 2026) e' quella che ha CREATO
//    la sede unica. Questa scheda ne teneva tre COPIE LOCALI — la lista tipi
//    era per giunta MONCA (mancava «Polo-Shirt», difetto U-Q3) e il criterio
//    di spettanza era ASIMMETRICO (squadra dalla tessera, ruolo dal
//    documento: difetto U-Q9). `RUOLI_CON_DIVISE` non si importa piu': la
//    regola «chi riceve divise per ruolo» vive dentro `tipiDivisaSpettanti`.
//  - la Fetta B del cantiere UNIFORMS-UI (settembre 2026) ha reso la lista dei
//    capi GESTIBILE PER ANNO (`items` del catalogo: id, label, hasSize,
//    active, order). Da allora `TIPI_DIVISA` e' il RIPIEGO, non piu' la
//    lista: questa scheda (fetta gemella, UNIF3-8) non lo importa piu' e
//    legge i capi da `capiDelCatalogo` / `capiAttivi` / `capoHaTaglia`, le
//    stesse funzioni della pagina Uniform Distribution. La regola «items
//    null → gli otto storici» vive la', in un punto solo: qui non si riscrive.
//  - dal cantiere UNIFORMS-ANNO (Fetta 3) anche le CONSEGNE si leggono da
//    li': `consegneDellAnnata(user, anno)` applica la regola «la fetta
//    dell'anno (`uniformsSeasons`) se c'e'; altrimenti, solo per il 2026, il
//    piatto `uniforms`; altrimenti niente». Questa scheda non legge piu'
//    `user.uniforms` direttamente: dopo il battesimo e' una fotografia ferma.
import {
  etichettaStato,
  tipiDivisaSpettanti,
  capiDelCatalogo,
  capiAttivi,
  capoHaTaglia,
  consegneDellAnnata
} from "../utils/uniforms";
// Le quote dell'anno operativo (RD-161): la sede unica del client, gemella di
// `consegneDellAnnata` qui sopra.
import { quoteDellAnnata } from "../utils/quote";
// LA CATEGORIA E' QUELLA DELLA PERSONA, non quella della squadra (VP2/F1):
// genere piu' eta' al 31 dicembre dell'ANNO OPERATIVO. E' la stessa lettura
// gia' in uso in UsersList e TeamAssignment: la scheda smette cosi' di
// mostrare una pastiglia diversa dalle liste, con la stessa forma.
// `genereCanonico` serve alla resa per esteso del campo «Gender» (VP2/F4a):
// la canonizzazione non si riscrive, si chiama.
import { categoriaAnagrafica, genereCanonico } from "../utils/categoria";
// L'IDONEITA' AL PROGRAMMA PLAY FOOTBALL — definizione unica dell'app
// (PLAYER o COACH, per ruolo o per tessera attiva). Qui decide se le due
// righe di Play Football si disegnino affatto (VP2/F3).
import { isPlayFootballEligible } from "../utils/playFootball";
// IL METRO DELL'ANNO, sede unica: serve a cercare la chiave dell'annata
// dentro `playFootballSeasons`, che il documento puo' portare come stringa
// o come numero (VP2/F3).
import { annoDiLista } from "../utils/stagione";
import { PastigliaCategoriaSeNota } from "./PastigliaCategoria";
// L'età compiuta con la STESSA regola di calendario del server
// (`isMinorDaDob`): il club vive a Perth e il compleanno non ancora arrivato
// vale un anno in meno. Le funzioni esistono già da RL-5a — riusarle, invece
// di riscrivere il conto, è ciò che impedisce alle due rese di divergere nel
// giorno del compleanno.
// ⚠️ `GENERI` E' IL VOCABOLARIO CANONICO DEL GENERE (valore «M»/«F»,
// etichetta «Male»/«Female»): lo usano tutti i moduli d'iscrizione, e da
// VP2/F4b lo usa anche la tendina di «Create & Link Child», che scriveva
// la parola per esteso mentre il server accetta la lettera.
// `messaggioDelServer` legge il corpo dell'errore di `api.js`: serve al 409
// «stagione illeggibile» del ramo COACH (VP2/F5).
import {
  etaCompiuta,
  GENERI,
  messaggioDelServer,
  oggiAPerth
} from "../utils/enrolDati";

// ------------------------------------------------------------------
// LE DESCRIZIONI DELLE SEZIONI (doc 07 §11.3).
//
// ⚠️ REGOLA DEI TESTI (decisione del committente, 22/8/2026, che sostituisce
// la resa della fase 4a): la descrizione dice COSA È la sezione e A COSA
// SERVE — MAI l'elenco dei campi. I campi sono già disegnati sotto: ripeterli
// nel pannello lo trasformava in una didascalia inutile, che invecchia a ogni
// campo aggiunto o tolto.
//
// I dodici testi qui sotto sono quelli DETTATI dal committente, alla lettera.
// In inglese, come ogni testo a schermo (CLAUDE.md §3.7).
//
// ⚠️ `management` è l'unica voce che il committente non ha riscritto: la sua
// riga era già conforme alla regola — dice che cos'è la sezione («azioni
// amministrative»), non quali pulsanti contenga — e resta quella della
// specifica di cantiere. Segnalato in consegna.
//
// ⚠️ La riga *Purpose* della specifica NON è più la sorgente di questi testi:
// se un giorno la specifica verrà riallineata, è la specifica a doversi
// muovere verso queste dodici frasi, non il contrario.
// ------------------------------------------------------------------
const DESCRIZIONI = {
  core: "Who this member is and how to reach them.",
  documents: "Official documents proving the member's identity.",
  wellbeing: "What the club should know to support this member well.",
  family: "Who this member is connected to within the club.",
  /* TESTO PROVVISORIO — doc 07 §11 */
  roles: "This member's roles and teams for the season shown.",
  registration: "This member's standing as a registered footballer.",
  uniforms: "Club kit issued to this member.",
  wwc: "The clearance required to work with minors.",
  fees: "Where this member stands financially with the club.",
  record: "How and when this member's record came to be.",
  notes: "Private staff observations about this member.",
  evaluation: "The coach's assessment of this player.",
  management: "Administrative actions (buttons that do something, not data)."
};

// ------------------------------------------------------------------
// SEZIONE-CARD (doc 07 §8 card, §11.2 gruppi, §11.3 icona «i»).
//
// ⚠️ L'icona e' un <button>, non uno <span> con onClick: e' un comando, deve
// essere raggiungibile da tastiera e annunciato da un lettore di schermo. Il
// pannello si apre AL TOCCO e si richiude al secondo tocco; l'oro dell'hover
// e' un extra da computer, schermato nel CSS (§11.3: mai un tooltip
// solo-hover).
// ------------------------------------------------------------------
const Sezione = ({ chiave, titolo, aperte, onApri, children }) => {
  const aperta = Boolean(aperte[chiave]);

  return (
    <section className="qpsc-vp-card">
      <div className="qpsc-vp-card__head">
        <h2 className="qpsc-vp-card__title">{titolo}</h2>

        <button
          type="button"
          className={"qpsc-vp-info" + (aperta ? " qpsc-vp-info--open" : "")}
          aria-expanded={aperta}
          aria-controls={`qpsc-vp-purpose-${chiave}`}
          aria-label={`What is “${titolo}”?`}
          onClick={() => onApri(chiave)}
        >
          <span className="qpsc-vp-info__glyph" aria-hidden="true">i</span>
        </button>
      </div>

      {aperta && (
        <p className="qpsc-vp-purpose" id={`qpsc-vp-purpose-${chiave}`}>
          {DESCRIZIONI[chiave]}
        </p>
      )}

      {children}
    </section>
  );
};

// Un campo: etichetta a SINISTRA e valore a DESTRA, sulla stessa riga
// (fase 4b, tavola approvata). Il markup non cambia rispetto alla fase 4a —
// e' lo stesso etichetta+valore — cambia solo come il foglio lo dispone.
// Il valore assente
// non e' un vuoto muto — si dichiara con un trattino in testo secondario, cosi'
// «non compilato» e «compilato» non si confondono.
// Con `children` il valore e' un nodo (un pulsante, un elenco) e la resa del
// vuoto non si applica.
const Campo = ({ etichetta, valore, children }) => {
  const vuoto =
    children === undefined &&
    (valore === null || valore === undefined || valore === "");

  // ⚠️ Il valore è un <div>, non uno <span>: con `children` ci finisce dentro
  // anche un elenco (le squadre approvate del gruppo 4), e un <ul> dentro uno
  // <span> non è markup valido.
  return (
    <div className="qpsc-vp-field">
      <span className="qpsc-vp-field__label">{etichetta}</span>
      <div
        className={
          "qpsc-vp-field__value" + (vuoto ? " qpsc-vp-field__value--empty" : "")
        }
      >
        {children !== undefined ? children : vuoto ? "—" : valore}
      </div>
    </div>
  );
};

// R9.9: lo status di una tessera, reso leggibile — ACTIVE → Active,
// PENDING → Pending, ARCHIVED → Archived; una grafia storica già mista
// ("Active") esce uguale. Sola RESA a schermo: il dato non si tocca. Un valore
// assente o vuoto torna "", e `Campo` lo dichiara col suo trattino.
const statoLeggibile = (valore) => {
  const testo = String(valore ?? "").trim();
  if (!testo) return "";
  return testo.charAt(0).toUpperCase() + testo.slice(1).toLowerCase();
};

// ⚠️ Il documento completo NON arriva piu' dalla prop.
// GET /users porta ormai i soli campi che servono a disegnare le righe di una
// lista (cantiere U1-S, punto 2): recapiti, contatti d'emergenza e documenti
// non viaggiano piu' in elenco. Il profilo intero si ricarica qui, da
// GET /users/:id.
//
// La matrice dei permessi e' ORA IN VIGORE sul backend (cantiere U1-S, punti
// 4 e 6-bis): ADMIN/SUPERADMIN attivi vedono qualunque profilo, ciascuno vede
// il proprio, un COACH attivo vede i tesserati delle squadre che allena.
// Chiunque altro riceve 403, e a quel punto qui si mostra il messaggio unico.
//
// ⚠️ Questo componente comunque non protegge nulla: il gate vero e' sul
// backend, qui si chiede il dato dove il dato sta.
//
// ⚠️ NON E' UNA FINESTRA (cantiere View Profile, fase 3 — doc 07 §11.1).
// La scheda e' una PAGINA su rotta propria, `/profile/:id`, vestita del telaio
// condiviso `HomeShell` (barra utente + banda con il SOLO «‹ Back»: «Switch
// role» e' un comando delle home, qui non compare). Il nome del file resta
// quello di prima perche' rinominarlo e' un'operazione di git, fuori
// dall'incarico.
// Da cio' discendono le tre differenze rispetto alla finestra:
//   1. l'id NON arriva da una prop ma dalla ROTTA (`useParams`); sulla rotta
//      `/myprofile`, che non porta id, e' quello dell'utente collegato;
//   2. la chiusura non e' una «×» ma il «Back» della banda: si torna indietro
//      nella cronologia, e se cronologia non ce n'e' (link diretto,
//      ricaricamento) si ripiega sull'instradatore `/home`;
//   3. i profili collegati non montano una seconda scheda sopra la prima:
//      NAVIGANO a `/profile/:altroId`, e il «Back» risale la pila.
// Le finestre aperte DA questa pagina (Edit, Link, Create Child) restano
// finestre: hanno guscio proprio e non diventano rotte.
//
// ⚠️ IL CONTENUTO E' RIDISEGNATO NELLE TREDICI SEZIONI (fase 4a — doc 07
// §11.2), nell'ordine fisso che il cantiere ha stabilito, ciascuna una card
// §8 con l'icona «i» del §11.3. La testata porta foto, nome, stato, «Minor» e
// la pastiglia categoria: IL RUOLO NON STA PIU' IN TESTATA, e' sceso nel
// gruppo 5a.

/* ===============================
   LA SQUADRA E L'ANNATA — le quattro copie di pagina NON CI SONO PIU'

   Qui vivevano `annoDiLista`, `squadreDellaTessera`, `tesseraValida` ed
   `eTesseraAmministrativa`: copie dichiarate delle gemelle di
   `UsersList.jsx` e `TeamAssignment.jsx`, in attesa — parole del commento
   che stava qui — del «modulo condiviso, materia del cantiere lettore
   unico». Quel modulo ora esiste, e sono due: `utils/stagione.js` per
   l'anno, `utils/squadre.js` per la tessera e le sue squadre. I corpi sono
   quelli di qui, invariati: non e' stata riscritta una riga, sono state
   tolte quattro copie.

   Si importano in testa al file. Le due chiamate di questa scheda stanno
   piu' sotto, fra gli hook (`tessereOperative`, `squadreDelSoggetto`), e la
   resa di «Active Roles» chiama `squadreDellaTessera` per tessera.
=============================== */

const MemberProfileModal = () => {

  // Chi guarda e' l'UTENTE COLLEGATO, e nient'altro. Da qui si ricavano
  // entrambe le cose che servono: CHI e' (per "e' il suo profilo?") e QUALI
  // RUOLI POSSIEDE (per i comandi). Sta qui in cima, con gli altri hook,
  // perche' piu' sotto il componente ha dei return anticipati.
  // ⚠️ `operatingSeason` E' IL TERZO VALORE CHE SERVE QUI, e viene dalla
  // stessa cassettina: l'ANNO OPERATIVO del club, gia' normalizzato a intero
  // da AuthContext (YS-5). Lo prendono di qui, con la stessa riga, UsersList e
  // TeamAssignment: nessuna chiamata propria a `GET /season-config`, e un solo
  // posto che dice l'annata. Fuori da `seasonStatus: "ready"` vale `null`, e
  // il predicato dell'anno lo tratta come «annata ignota».
  // ⚠️ `seasonStatus` E' IL QUARTO VALORE, e da VP2/F5 non e' un di piu':
  // e' il cancello della pagina. Vale "loading" | "ready" | "error", e fuori
  // da "ready" i due anni sono `null`.
  // ⚙️ `enrollmentSeason` / `enrollmentsOpen` (cantiere RINNOVO-FIGLI-ADMIN)
  // servono al SOLO comando «Renew children» delle Management Actions: la
  // scheda continua a mostrare l'anno OPERATIVO e nient'altro. Stessa lettura
  // di EnrolNextSeason.jsx, dalla stessa cassettina.
  const {
    user: utenteCollegato,
    refreshUserFromBackend,
    operatingSeason,
    seasonStatus,
    enrollmentSeason,
    enrollmentsOpen
  } = useAuth() || {};

  // Con `useAuth() || {}` il valore puo' arrivare `undefined` (contesto non
  // montato): si riconduce all'unico nullo che il predicato conosce.
  const annoOperativo = operatingSeason == null ? null : operatingSeason;

  // ------------------------------------------------------------------
  // LA STAGIONE SI LEGGE, SI'/NO (VP2/F5, decisione 4 del committente).
  //
  // ⚠️ QUESTA SCHEDA MOSTRA «ADESSO», cioe' l'anno OPERATIVO, e null'altro.
  // Se l'anno non si sa, la scheda NON si apre: non esiste una resa di
  // ripiego onesta. Senza cancello il predicato dell'anno, per non rompere
  // l'app, lascia passare TUTTE le tessere attive di TUTTE le annate
  // (`utils/squadre.js`: «anno === null» vale «annata ignota, nessun
  // cancello») — e la scheda mostrerebbe, senza dirlo, un miscuglio di
  // stagioni spacciato per l'anno in corso. Meglio una riga sola che dice
  // «riprova» di una scheda piena di dati dell'anno sbagliato.
  //
  // ⚠️ I due pezzi si guardano ENTRAMBI: `seasonStatus` puo' dire "ready"
  // con `operatingSeason` a `null` (AuthContext normalizza i due anni in
  // modo indipendente), e la seconda meta' e' proprio quella che conta qui.
  // ------------------------------------------------------------------
  const stagioneLeggibile = seasonStatus === "ready" && annoOperativo !== null;

  const { id: idDallaRotta } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [showCamera, setShowCamera] = useState(false);
  const [uploadingSelfie, setUploadingSelfie] = useState(false);
  const webcamRef = useRef(null);

  // Le descrizioni di sezione aperte, per chiave (doc 07 §11.3). Piu' d'una
  // puo' restare aperta: il §11.3 chiede che il secondo tocco richiuda, non
  // che l'apertura di una chiuda le altre.
  const [descrizioniAperte, setDescrizioniAperte] = useState({});

  const apriDescrizione = useCallback((chiave) => {
    setDescrizioniAperte((aperte) => ({
      ...aperte,
      [chiave]: !aperte[chiave]
    }));
  }, []);

  // L'id della scheda da mostrare. `/profile/:id` lo porta nella rotta;
  // `/myprofile` non lo porta, e allora e' quello dell'utente collegato.
  const idProfilo = idDallaRotta || utenteCollegato?.id;

  // LA VIA D'USCITA, una sola per tutta la pagina: il «Back» della banda, la
  // chiusura dopo un Delete riuscito, il ritorno da una scheda collegata.
  // ⚠️ `location.key === "default"` e' il modo di react-router v6 per dire
  // «questa e' la prima voce della cronologia»: ci si arriva per link diretto,
  // segnalibro o ricaricamento della pagina. In quel caso `navigate(-1)`
  // uscirebbe dall'app (o non farebbe nulla), e la persona resterebbe in un
  // vicolo cieco: si ripiega sull'instradatore `/home`, che manda ciascuno
  // alla home del proprio ruolo. `replace` per non lasciare dietro una voce
  // che riporterebbe qui.
  const tornaIndietro = useCallback(() => {
    if (location.key === "default") {
      navigate("/home", { replace: true });
    } else {
      navigate(-1);
    }
  }, [location.key, navigate]);

  // "caricamento" | "pronto" | "errore"
  const [statoProfilo, setStatoProfilo] = useState("caricamento");
  const [localUser, setLocalUser] = useState(null);

  // L'AVVISO DA MOSTRARE AL POSTO DELLA SCHEDA, quando ce n'e' uno PIU'
  // PRECISO dell'esito unico (VP2/F5). Vuoto = resta la frase di sempre,
  // quella che non lascia capire se la persona esista.
  const [avvisoProfilo, setAvvisoProfilo] = useState("");

  // Da qui in giu' `user` e' il documento caricato dal backend.
  const user = localUser;

  const [config, setConfig] = useState(null);

  const [linkedProfiles, setLinkedProfiles] = useState([]);

  // I genitori/tutori del profilo aperto (correzione D1). Ogni voce e'
  // { id, profile } se la lettura e' riuscita, { id, error: true } se e'
  // stata rifiutata: l'elenco tiene comunque il posto di OGNI tutore, anche
  // di quelli che chi guarda non ha il permesso di leggere.
  const [guardianProfiles, setGuardianProfiles] = useState([]);

  // (`selectedLinkedUser` non esiste piu': i profili collegati non si
  //  montano dentro questa scheda, ci si NAVIGA — fase 3.)
  const [showLinkPlayer, setShowLinkPlayer] = useState(false);
  const [allPlayers, setAllPlayers] = useState([]);
  const [selectedPlayerId, setSelectedPlayerId] = useState("");

  // «RENEW CHILDREN» (cantiere RINNOVO-FIGLI-ADMIN). Il TITOLO al rinnovo di
  // ogni socio, per id: e' il `renewableSeasons` che GET /users (elenco) gia'
  // calcola sul server con `ruoliDaRinnovare`, la sede unica della regola. Il
  // client non la ricopia: legge soltanto se l'anno d'iscrizione e' fra quelli.
  // Si riempie dalla STESSA lettura dell'elenco che serve a «Link Existing
  // Player» (piu' sotto), PRIMA del suo filtro PLAYER: un figlio registrato
  // con altro ruolo non deve sparire da qui.
  const [titoliRinnovo, setTitoliRinnovo] = useState({
    stato: "caricamento",
    perId: {}
  });
  const [showRenewChildren, setShowRenewChildren] = useState(false);
  const [sceltiRinnovo, setSceltiRinnovo] = useState([]);
  const [invioRinnovo, setInvioRinnovo] = useState(false);
  const [esitoRinnovo, setEsitoRinnovo] = useState(null);
  // ⚠️ METRO UNICO DI «CHI GUARDA» (cantiere View Profile, fase 1).
  // Il ruolo di chi guarda si legge per POSSESSO dall'utente collegato —
  // `role` di primo livello PIU' i context ACTIVE, cioe' il gate unico di
  // `auth/access.js` — e non da una stringa che il chiamante passava
  // dall'esterno (`currentUserRole`, tolta dalla firma in fase 1). Era il
  // difetto gia' chiuso in EditMemberModal e sul pallino Alert in P3:
  // una prop del genere e' cieca ai context, la passavano solo tre dei cinque
  // chiamanti, e ognuno ci metteva una cosa diversa — UsersList il `role` di
  // primo livello, TeamAssignment lo stesso, AttendanceSummary il CAPPELLO
  // INDOSSATO (`activeContext.role`), cosi' un admin che allena, mentre porta
  // il cappello del coach, perdeva i comandi che il backend gli concede.
  // Da qui in giu' il metro e' uno solo, ed e' lo stesso del backend.
  const chiamanteEAdmin = hasRole(utenteCollegato, "ADMIN", "SUPERADMIN");
  const chiamanteESuperAdmin = hasRole(utenteCollegato, "SUPERADMIN");

  const [showCreateChild, setShowCreateChild] = useState(false);

  // Archiviazione in corso della richiesta «gioco/alleno anch'io» (RL-7d-2):
  // serve solo a spegnere il bottone finche' il PUT e' in volo, cosi' un
  // secondo clic non parte. Sta qui in cima con gli altri hook, perche' piu'
  // sotto il componente ha dei return anticipati.
  const [archiviandoRichiesta, setArchiviandoRichiesta] = useState(false);

  // Invio in corso del link d'accesso (cantiere LINK-ACCESSO, F2): stesso
  // mestiere del flag qui sopra, spegne il bottone finche' la POST e' in volo.
  const [inviandoLink, setInviandoLink] = useState(false);

  // ⚠️ IL GENERE NASCE «M», NON «Male» (VP2/F4b, decisione 9 del
  // committente). Le rotte d'iscrizione del modello nuovo accettano la sola
  // lettera, e questa finestra scriveva invece la parola per esteso: ogni
  // figlio creato di qui nasceva con una grafia che i lettori canonici della
  // categoria e dei conteggi non riconoscono. L'etichetta a schermo resta la
  // parola: cambia il VALORE, non quello che si legge.
  const [newChild, setNewChild] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    gender: GENERI[0].valore,
    email: "",
    phone: ""
  });

  // L'id di cui una risposta e' ancora valida. La pagina puo' passare da una
  // persona a un'altra senza smontarsi: una lettura partita per il profilo
  // precedente, se arrivasse dopo il cambio, disegnerebbe la persona
  // sbagliata. Vale anche allo smontaggio, dove torna a null.
  const idInCorsoRef = useRef(null);

  // Lettura del profilo: GET /users/:id, la sola porta del documento intero
  // (cantiere U1-S, punto 2). Di qui passano l'apertura della scheda, il Link
  // e il Create Child, perche' le loro risposte non contengono il documento da
  // ridisegnare (audit 10 §A.5): il PUT torna i soli campi scritti,
  // /register-child torna il figlio. L'Edit invece passa di qui SOLO quando il
  // documento non arriva: nel percorso nominale EditMemberModal lo consegna
  // gia' letto e la scheda lo scrive direttamente.
  //
  // ⚠️ Non riporta mai lo stato a "caricamento": dopo un'azione la scheda e'
  // gia' aperta e piena, e svuotarla farebbe lampeggiare il messaggio d'attesa
  // su dati che ci sono.
  //
  // ⚠️ `svuotaSuRifiuto` distingue i due usi, e non e' un dettaglio. IN
  // APERTURA il rifiuto deve svuotare: non c'e' niente da mostrare, e il
  // messaggio unico non deve lasciar capire se quella persona esista. DOPO
  // UN'AZIONE RIUSCITA no: il salvataggio e' avvenuto, sotto c'e' una scheda
  // piena, e un guasto della sola rilettura la sostituirebbe con «This profile
  // is not available.» — cioe' un'azione andata a buon fine che finisce con un
  // messaggio che dice l'opposto. Meglio la scheda vecchia.
  const ricaricaProfilo = useCallback(async ({ svuotaSuRifiuto = false } = {}) => {
    if (!idProfilo) {
      setStatoProfilo("errore");
      return null;
    }

    try {
      const documento = await api.get(`/users/${idProfilo}`);

      if (idInCorsoRef.current !== idProfilo) return null;

      setAvvisoProfilo("");
      setLocalUser(documento);
      setStatoProfilo("pronto");
      return documento;
    } catch (err) {
      // Un solo esito per ogni rifiuto (403, 404, errore tecnico): la pagina
      // non deve lasciar capire se quella persona esista.
      //
      // ⚠️ UN CASO SOLO FA ECCEZIONE, ed e' il 409 (VP2/F5). Il ramo COACH di
      // `GET /users/:id` risponde 409 quando la cassettina della stagione non
      // si legge: non e' un rifiuto, e' un guasto momentaneo del club. Il
      // server ha gia' la frase giusta, scritta apposta e in inglese; finora
      // la scheda la buttava via e diceva «questo profilo non e' disponibile»
      // — una frase FALSA, che manda l'allenatore a chiedere permessi che ha
      // gia'. Qui si legge `err.status` e, sul 409, si mostra la frase del
      // server. Su 403, 404 e guasto di rete non cambia nulla: esito unico.
      if (idInCorsoRef.current !== idProfilo) return null;

      /* TESTO PROVVISORIO — doc 07 §11 */
      const avviso =
        err && err.status === 409
          ? messaggioDelServer(err) ||
            "Could not read the club season. Please try again in a moment."
          : "";

      if (svuotaSuRifiuto) {
        setAvvisoProfilo(avviso);
        setLocalUser(null);
        setStatoProfilo("errore");
      }

      return null;
    }
  }, [idProfilo]);

  // ⚠️ ERA LA PROP `onUpdate` (fase 3). Fino alla fase 3 ogni chiamante passava
  // la propria: UsersList rileggeva l'elenco, TeamAssignment rileggeva
  // `/users`, `/myprofile` rileggeva l'utente collegato, AttendanceSummary non
  // passava nulla. Da quando la scheda e' una PAGINA quelle riletture non
  // servono piu': la pagina di partenza si e' SMONTATA, e il «Back» la
  // rimonta — e ogni elenco rilegge da se' al montaggio.
  // Resta un solo effetto che il ritorno non produrrebbe da solo: se la scheda
  // e' quella dell'UTENTE COLLEGATO, l'`user` di AuthContext va riscritto,
  // altrimenti resterebbe quello di prima fino a un nuovo login (P9, voce 4).
  // Si passa dalla sede unica, `refreshUserFromBackend`, che rilegge da se' e
  // non tocca il cappello indossato.
  //
  // R9.10: la rilettura si ATTENDE, con un catch proprio, come in
  // UserContextManager — è solo una lettura dopo un salvataggio riuscito: se
  // fallisce lo si annota in console e non si dice nulla a schermo, ma la
  // promessa non resta senza gestione.
  const propagaAggiornamento = useCallback(async () => {
    if (idProfilo && utenteCollegato?.id === idProfilo && refreshUserFromBackend) {
      try {
        await refreshUserFromBackend();
      } catch (err) {
        console.error("User reload failed after save:", err);
      }
    }
  }, [idProfilo, utenteCollegato?.id, refreshUserFromBackend]);

  // Caricamento del profilo intero. Sta qui, sotto le dichiarazioni degli
  // stati che azzera, per non dipendere dall'ordine di inizializzazione.
  useEffect(() => {
    // ⚠️ SI ENTRA DALL'ALTO (riserva R1 della revisione di fase 3, chiusa qui).
    // Finche' la scheda era una finestra `position: fixed` compariva sempre in
    // mezzo allo schermo, qualunque fosse lo scorrimento della pagina sotto.
    // Ora e' nel flusso del documento: un admin che scorre in fondo a /users e
    // preme «View Profile» aprirebbe la scheda gia' scorsa in basso, e il
    // passaggio /profile/A → /profile/B non riporterebbe su nemmeno quello,
    // perche' il componente NON si smonta e il browser non ha motivo di
    // reimpostare la posizione.
    //
    // SEDE SCELTA: QUI, non un ScrollToTop condiviso nel telaio. E' la sede
    // MINIMA — l'effetto e' legato a `idProfilo`, quindi scatta sia
    // all'apertura sia a ogni cambio di soggetto, e non tocca una sola altra
    // pagina dell'app. Un componente nel telaio sarebbe una decisione su TUTTE
    // le pagine ricostruite, che questo incarico non ha titolo per prendere;
    // se domani la si prendera', questa riga si toglie.
    window.scrollTo(0, 0);

    if (!idProfilo) {
      setStatoProfilo("errore");
      return undefined;
    }

    setStatoProfilo("caricamento");
    setLocalUser(null);
    // Anche i derivati vanno azzerati: se la pagina passa da una persona a
    // un'altra senza smontarsi, i profili collegati della precedente non
    // devono sopravvivere al cambio.
    setLinkedProfiles([]);
    setAllPlayers([]);

    // ⚠️ E CON LORO LE FINESTRE FIGLIE (riserva R3 della revisione di fase 3).
    // Da quando la scheda e' una pagina, il soggetto puo' cambiare SENZA che
    // il componente si smonti: due voci di cronologia sulla stessa rotta —
    // `/profile/B` e l'indietro del browser verso `/profile/A`. Una finestra
    // aperta su B sopravviverebbe al cambio e si troverebbe addosso ad A:
    // «Link Player» comparirebbe su una persona che nessuno ha chiesto di
    // collegare. Il dato non si corrompe (le finestre leggono `user`, che e'
    // gia' cambiato), ma un modulo che si apre da se' e' comportamento
    // sbagliato: al cambio di soggetto si chiudono tutte.
    // ⚠️ «Edit Member» non e' piu' in questo elenco, e non e' una svista: da
    // quando e' una PAGINA con un indirizzo suo non puo' sopravvivere al
    // cambio di soggetto — cambiare persona significa lasciarla.
    setShowLinkPlayer(false);
    setShowCreateChild(false);
    setShowCamera(false);

    idInCorsoRef.current = idProfilo;
    // In apertura, e solo qui, il rifiuto svuota: vedi il commento sopra.
    ricaricaProfilo({ svuotaSuRifiuto: true });

    return () => {
      idInCorsoRef.current = null;
    };
  }, [idProfilo, ricaricaProfilo]);

  // IL CATALOGO DELLE DIVISE, DELL'ANNO OPERATIVO E DICHIARANDOLO (UNIF3-8,
  // opzione B del committente). Questa scheda mostra «adesso» in tutto
  // (tessere, squadra, quote, testata «Season {anno}»): il catalogo si chiede
  // per lo STESSO anno, scritto nella chiamata — `GET /uniform-config?season=`
  // — invece di fidarsi del default del server. Calco della pagina Uniform
  // Distribution (`UniformDistribution.jsx`, UNIFORMS-UI/Fetta B), che legge
  // per l'anno guardato; qui l'anno guardato e' l'operativo e basta.
  //
  // ⚠️ NON PARTE PRIMA CHE L'ANNO SIA NOTO: all'apertura `annoOperativo` puo'
  // essere ancora `null` (cassettina in arrivo), e un `?season=null` sarebbe
  // un 400 del server. Si aspetta il cancello `stagioneLeggibile`, lo stesso
  // sotto cui la pagina si disegna; la bandierina `attivo` scarta la risposta
  // di una lettura superata dallo smontaggio (l'anno operativo non cambia
  // dentro la scheda, il montaggio si'). La risposta si salva INTERA, com'era:
  // `items` compreso, che e' cio' che la lista dei capi legge.
  useEffect(() => {
    if (!stagioneLeggibile) return undefined;

    let attivo = true;

    const fetchConfig = async () => {
      try {
        const percorso = Number.isInteger(annoOperativo)
          ? `/uniform-config?season=${encodeURIComponent(annoOperativo)}`
          : "/uniform-config";
        const data = await api.get(percorso);
        if (attivo) setConfig(data);
      } catch (err) {
        if (attivo) console.error("Failed to load config", err);
      }
    };
    fetchConfig();

    return () => {
      attivo = false;
    };
  }, [annoOperativo, stagioneLeggibile]);

  // ------------------------------------------------------------------
  // LE TESSERE DELL'ANNO OPERATIVO — sede unica della squadra in questa
  // scheda.
  //
  // ⚠️ STA QUI IN ALTO, FRA GLI HOOK, e non accanto agli altri derivati della
  // vista: e' un `useMemo`, e piu' sotto il componente ha due return
  // anticipati — un hook dopo un return non si puo' scrivere.
  //
  // ⚠️ DUE INSIEMI, DI PROPOSITO — e' l'eccezione amministrativa gia' scritta
  // in `UsersList.jsx` (`tessereDiRuolo`):
  //   - le tessere DELL'ANNATA (player, coach), in qualunque stato;
  //   - piu' le tessere AMMINISTRATIVE attive, che annata non hanno e non
  //     possono averla. Compaiono sempre, squadra non ne portano.
  // In sovrapposizione — quando l'anno d'iscrizione e' gia' aperto accanto
  // all'operativo — la scheda mostra percio' la sola tessera OPERATIVA.
  //
  // ⚠️ TUTTI GLI STATI, NON LE SOLE ATTIVE (VP2/F2, decisione 2 del
  // committente). `stati: null` vale «qualunque stato» — e' l'opzione che
  // `utils/squadre.js` documenta e che Team Assignment usa gia': la scheda
  // di una persona deve dire tutto quello che quella persona E' quest'anno,
  // compreso l'in attesa (PENDING) e l'archiviato (ARCHIVED). Erano proprio
  // le tessere che a schermo mancavano di piu': un iscritto in attesa
  // appariva come uno senza alcun ruolo.
  //
  // ⚠️ NON SI RIENTRA sulle tessere MUTE (senza `cardSeason`): `senzaAnno`
  // resta al default «escludi». Una tessera che non dice la propria annata
  // non e' «di quest'anno», e questa scheda mostra l'anno operativo.
  //
  // ⚠️ A STAGIONE ILLEGGIBILE NON SI CALCOLA NULLA: senza cancello il
  // predicato lascerebbe passare le tessere di ogni annata. La pagina in
  // quel caso non si disegna affatto (`stagioneLeggibile`, piu' sopra), ma
  // l'insieme resta vuoto anche qui, cosi' nessun calcolo a valle — squadre,
  // categoria, divise — vede mai un miscuglio di anni.
  //
  // ⚠️ QUESTO INSIEME NON PORTA SQUADRE — l'apertura agli stati finisce qui.
  // Serve alla sola card dei ruoli («Membership {anno}», gruppo 4). Il campo
  // «Team» (5a) e le righe delle DIVISE (5b) scendono invece dal derivato
  // subito sotto, `tessereAttiveOperative`, che e' fermo alle sole ACTIVE:
  // chi quest'anno ha una sola tessera in attesa o archiviata compare fra i
  // ruoli, ma squadra e divise restano vuote come prima di VP2. E' la «Via 2»
  // decisa dal committente il 2/9 (addendum A), dopo che l'esecuzione base
  // aveva segnalato l'effetto collaterale.
  // ------------------------------------------------------------------
  const tessereOperative = useMemo(
    () =>
      stagioneLeggibile
        ? tessereDelSoggetto(localUser?.contexts, annoOperativo, {
            includiAmministrative: true,
            stati: null
          })
        : [],
    [localUser, annoOperativo, stagioneLeggibile]
  );

  // ------------------------------------------------------------------
  // LE SOLE TESSERE ATTIVE DELL'ANNO OPERATIVO — sorgente di SQUADRA e DIVISE.
  //
  // ⚠️ DUE DERIVATI, DI PROPOSITO (addendum A, «Via 2», 2/9). Dire che una
  // persona ha quest'anno una tessera in attesa non e' dire che gioca in
  // quella squadra: la card dei ruoli apre a tutti gli stati, il campo «Team»
  // (5a) e la tabella delle DIVISE (5b) no. Questa e' la chiamata ORIGINARIA,
  // quella di prima di VP2: `stati` lasciati al default `["ACTIVE"]` del
  // modulo condiviso, `includiAmministrative: true` invariato. Nessuna regola
  // nuova, nessun ramo: un Player ha sempre e solo una squadra.
  //
  // ⚠️ STESSO CANCELLO DI STAGIONE dell'insieme qui sopra, per la stessa
  // ragione: a stagione illeggibile non si calcola nulla, cosi' squadra e
  // divise non vedono mai un miscuglio di anni.
  // ------------------------------------------------------------------
  const tessereAttiveOperative = useMemo(
    () =>
      stagioneLeggibile
        ? tessereDelSoggetto(localUser?.contexts, annoOperativo, {
            includiAmministrative: true
          })
        : [],
    [localUser, annoOperativo, stagioneLeggibile]
  );

  // LE SQUADRE DEL SOGGETTO NELL'ANNO OPERATIVO, nella coppia canonica.
  //
  // ⚠️ E' l'unione delle tessere operative, non la lettura di una sola: una
  // persona puo' avere piu' tessere nello stesso anno (un coach di due
  // squadre, un giocatore che allena). `allTeams` di una qualunque vince su
  // tutto — «tutte le squadre» non si somma, assorbe.
  //
  // ⚠️ SI PARTE DALLE TESSERE GIA' SCELTE, non dai `contexts`, e non e' un
  // dettaglio: ripartire da capo farebbe girare il filtro DUE VOLTE. Per
  // questo il modulo espone l'unione da sola.
  //
  // ⚠️ LA BASE E' `tessereAttiveOperative`, NON `tessereOperative` (addendum
  // A, «Via 2»): le squadre nascono dalle sole tessere ACTIVE dell'anno.
  // L'insieme che «Active Roles» rende a schermo (`contestiAttivi`, piu'
  // sotto, E' `tessereOperative`) e' piu' largo di questo, ed e' giusto cosi'.
  const squadreDelSoggetto = useMemo(
    () => squadreDelleTessere(tessereAttiveOperative),
    [tessereAttiveOperative]
  );

  // ⚠️ QUI STAVA `squadraDelSoggetto` (`squadreDelSoggetto.nomi[0] || ""`),
  // il NOME della squadra che serviva SOLO alla tabella delle divise (gruppo
  // 5b). Cade con la Fetta C: la squadra della spettanza la legge ora la sede
  // unica (`tipiDivisaSpettanti` → `primaSquadraDellaTessera`), dalla TESSERA
  // PLAYER e non dall'unione di tutte le tessere. Il campo «Team» (gruppo 5a)
  // non la usava: legge `squadreDelSoggetto` (al plurale), che resta.

  // ------------------------------------------------------------------
  // LA CATEGORIA DELLA PASTIGLIA IN TESTATA (doc 07 §2, §11.2).
  //
  // ⚠️ E' L'ANAGRAFICA DELLA PERSONA, NON LA CATEGORIA DELLA SQUADRA
  // (VP2/F1, decisione 5 del committente). Fino a qui la pastiglia diceva la
  // categoria del DOCUMENTO SQUADRA, cercata per nome in `GET /teams`: la
  // stessa forma e lo stesso posto della pastiglia delle liste, ma un altro
  // dato — e su una squadra MIXED un timbro che l'anagrafica non produce
  // mai. Ora la domanda e' una sola in tutta l'app: che categoria ha QUESTA
  // PERSONA in QUESTA annata.
  //
  // ⚠️ L'ETA' SI MISURA AL 31 DICEMBRE DELL'ANNO OPERATIVO, non su oggi: e'
  // dentro `categoriaAnagrafica`, e l'annata che le si passa e' l'intero
  // dell'anno operativo (fuori da «stagione leggibile» questa pagina non si
  // disegna affatto, quindi qui l'anno c'e' sempre).
  //
  // ⚠️ LA PASTIGLIA TACE quando la persona non ha genere o non ha una data di
  // nascita leggibile — un genitore, un documento vecchio: `categoriaAnagrafica`
  // torna "" e `PastigliaCategoriaSeNota` non disegna nulla. Un timbro
  // indovinato sarebbe peggio del silenzio.
  //
  // ⚠️ CADE LA CHIAMATA `GET /teams`: serviva SOLO a questa pastiglia. La
  // scheda non chiede piu' l'elenco delle squadre del club per dire l'eta' di
  // una persona.
  // ------------------------------------------------------------------
  const categoria = useMemo(
    () => categoriaAnagrafica(localUser, annoOperativo),
    [localUser, annoOperativo]
  );

    // ⚠️ È il gate che ACCENDE la sezione «Family & Guardians» dal lato dei
    // figli, e fino a P4 era spento per chiunque abbia la grafia nuova:
    // `user?.role === "Parent"` non aggancia `role: "PARENT"`, così su un
    // genitore del modello nuovo l'elenco dei figli non si caricava MAI —
    // nemmeno riaprendo la scheda — e la sezione non compariva, perché più
    // sotto è subordinata a `linkedProfiles.length > 0` (audit 10 §A.3).
    //
    // ⚠️ `canonicalRole` e non `hasRole`, di proposito (P4/D6): la domanda è
    // «questo DOCUMENTO è un genitore?», non «questa persona possiede il
    // ruolo PARENT». Si legge il documento mostrato, e i suoi
    // `linkedProfiles` sono un campo di primo livello. Con `hasRole` si
    // caricherebbero i figli anche a un giocatore che abbia un context
    // PARENT attivo.
    //
    // ⚠️ I cancelli sono DUE, e nessuno dei due contiene l'altro:
    //   1. QUI si CARICA, e si guarda il solo `role` di primo livello;
    //   2. più sotto la SEZIONE si MOSTRA (`mostraFigli`), e chiede se la
    //      persona POSSIEDE il ruolo PARENT (`hasRole`: `role` di primo
    //      livello o context ACTIVE, canonico).
    // Questa fetta tocca solo il primo.
    //
    // Per il caso bersaglio — documento `role: "PARENT"` senza contexts —
    // passano entrambi, ed è il difetto che P4 chiude. Il genitore che
    // allena — documento `role: "PARENT"` con un context ACTIVE di ALTRO
    // ruolo, caso ordinario in un club — passa anch'esso entrambi i cancelli da
    // D-17, che ha portato il cancello di vista sul possesso di PARENT.
    // Resta scoperto un caso, da non cercare nel cancello sbagliato:
    //   (a) genitore SOLO per context: qui NON si carica (il suo `role` non
    //       è PARENT), mentre il cancello 2 passerebbe — la sezione resta
    //       vuota per mancanza di dati, non per la condizione di vista.
    // Divergenza accettata dal capomastro (P4/D6), a verbale; D-17 l'ha
    // lasciata fuori di proposito.
    //
    // ⚠️ `Promise.allSettled`, NON `Promise.all` (delta 8, fase 5). Ogni id
    // vive per conto suo, esattamente come per i tutori qui sotto: chi guarda
    // puo' non avere il permesso di leggere QUEL figlio (403), oppure il
    // documento puntato puo' non esistere piu'. Con `Promise.all` la prima
    // lettura rifiutata buttava via anche le altre — il `catch` lasciava
    // `linkedProfiles` vuoto e la sezione spariva INTERA, figli leggibili
    // compresi. Ora la voce fallita diventa una riga di ripiego e le altre si
    // disegnano lo stesso.
    //
    // ⚠️ FORMA GEMELLA DEI TUTORI, di proposito: stesso involucro
    // `{ id, profile }` / `{ id, error: true }`, stessa guardia `annullato`.
    // Senza la guardia una risposta in ritardo ripopolava i figli della
    // persona PRECEDENTE, perche' da quando la scheda e' una pagina il
    // soggetto cambia senza che il componente si smonti.
    //
    // ⚠️ IL CANCELLO DI CARICO E' QUELLO DI PRIMA: qui sotto si legge ancora il
    // solo `role` di primo livello (P4/D6, a verbale). Il delta 8 ha cambiato
    // la ROBUSTEZZA della lettura, non chi vede che cosa; il cancello di vista
    // `mostraFigli` l'ha poi cambiato D-17 (possesso di PARENT), chiudendo il
    // genitore che allena. Resta aperta la sola famiglia (a), genitore solo
    // per context.
    useEffect(() => {
      let annullato = false;

      const idsFigli =
        canonicalRole(user?.role) === "PARENT" && Array.isArray(user.linkedProfiles)
          ? user.linkedProfiles
              // L'id sta su `id` oppure su `profileId`, secondo l'eta' del
              // documento. Le voci senza alcun id si scartano qui: prima
              // diventavano una GET `/users/undefined` che, fallendo,
              // trascinava con se' tutti i fratelli.
              .map(lp => (lp && (lp.id || lp.profileId)) || "")
              .filter(id => typeof id === "string" && id.trim())
          : [];

      if (idsFigli.length === 0) return undefined;

      const caricaFigli = async () => {
        const esiti = await Promise.allSettled(
          idsFigli.map(id => api.get(`/users/${id}`))
        );

        if (annullato) return;

        setLinkedProfiles(
          esiti.map((esito, i) =>
            esito.status === "fulfilled" && esito.value
              ? { id: idsFigli[i], profile: esito.value }
              : { id: idsFigli[i], error: true }
          )
        );
      };

      caricaFigli();

      return () => {
        annullato = true;
      };
    }, [user]);

    // ------------------------------------------------------------------
    // I genitori/tutori del profilo aperto (correzione D1): il verso opposto
    // dei figli. Gemello della lettura qui sopra, con tre differenze che
    // contano e che non vanno "uniformate":
    //
    //   1. LA FORMA DEL CAMPO. `user.guardians` e' un array di STRINGHE —
    //      ciascuna e' l'id-documento del genitore, es. "member_…" — non di
    //      oggetti: si itera la stringa, non `lp.id || lp.profileId` come si
    //      fa con `linkedProfiles`.
    //   2. NESSUN CANCELLO DI RUOLO. Il campo lo porta il figlio: se il
    //      documento aperto ha dei tutori, quei tutori sono suoi, qualunque
    //      sia il ruolo di chi guarda o il contesto di chi e' aperto.
    //   3. OGNI ID VIVE PER CONTO SUO. Chi guarda potrebbe non avere il
    //      permesso di leggere quel genitore (403, ed e' il caso normale per
    //      un COACH): con `Promise.all` una sola lettura rifiutata
    //      cancellerebbe anche le altre e la sezione resterebbe vuota.
    //      Con `Promise.allSettled` la voce rifiutata diventa una riga di
    //      ripiego e le altre si disegnano lo stesso.
    //
    // ⚠️ E' una correzione DI SOLA VISTA: il 403 si assorbe qui, non si
    // chiede al backend di concedere di piu'.
    useEffect(() => {
      let annullato = false;

      const idsTutori = Array.isArray(user?.guardians)
        ? user.guardians.filter(id => typeof id === "string" && id.trim())
        : [];

      // Si svuota solo se l'elenco degli id e' DAVVERO cambiato: la pagina
      // rilegge il documento dopo ogni azione, e azzerare a ogni giro farebbe
      // sparire e riapparire la sezione senza motivo. Se invece la scheda
      // passa a un'altra persona, i tutori della precedente devono sparire
      // prima che arrivino i nuovi.
      setGuardianProfiles(precedenti =>
        precedenti.length === idsTutori.length &&
        precedenti.every((voce, i) => voce.id === idsTutori[i])
          ? precedenti
          : []
      );

      if (idsTutori.length === 0) return undefined;

      const caricaTutori = async () => {
        const esiti = await Promise.allSettled(
          idsTutori.map(id => api.get(`/users/${id}`))
        );

        if (annullato) return;

        setGuardianProfiles(
          esiti.map((esito, i) =>
            esito.status === "fulfilled" && esito.value
              ? { id: idsTutori[i], profile: esito.value }
              : { id: idsTutori[i], error: true }
          )
        );
      };

      caricaTutori();

      return () => {
        annullato = true;
      };
    }, [user]);

    useEffect(() => {
      const loadPlayers = async () => {
        try {
          const users = await api.get("/users");

          // «Renew children»: il titolo di OGNI socio, prima del filtro PLAYER
          // qui sotto (vedi lo stato `titoliRinnovo`). Solo gli anni: nessun
          // altro campo dell'elenco viene trattenuto.
          const perId = {};
          for (const u of Array.isArray(users) ? users : []) {
            if (u && u.id) {
              perId[String(u.id)] = Array.isArray(u.renewableSeasons)
                ? u.renewableSeasons
                : [];
            }
          }
          setTitoliRinnovo({ stato: "pronto", perId });

          // Il confronto era già tollerante alle due grafie, ma non al
          // vocabolario: un documento storico `role: "Child"` — un minore
          // tesserato — restava fuori dai giocatori collegabili.
          const players = users.filter(
            u => canonicalRole(u.role) === "PLAYER"
          );

          setAllPlayers(players);
        } catch (err) {
          console.error("Failed loading players", err);
          setTitoliRinnovo({ stato: "errore", perId: {} });
        }
      };

      // ⚠️ Chi guarda si riconosce col GATE UNICO, per POSSESSO (decisione 1
      // dell'8/8/2026), contexts compresi: aprire la via che collega un
      // figlio a un genitore è un COMANDO.
      //
      // ⚠️ PREZZO DICHIARATO DI P4, PAGATO nella fase 1 del cantiere View
      // Profile. Questa lettura e i due bottoni che ne usano l'elenco
      // («Link Existing Player», «Create & Link Child») misuravano chi guarda
      // in due modi diversi: qui il possesso, là la prop `currentUserRole`.
      // Un SUPERADMIN che portasse il ruolo solo via context faceva partire
      // una GET /users — l'elenco del club, minori compresi — per bottoni che
      // poi non vedeva. Caduta la prop, la condizione qui sotto e quella dei
      // bottoni (`chiamanteEAdmin`) sono la stessa: o si legge e si
      // vedono, o non si fa nessuna delle due cose.
      // Cantiere ADMIN-SA (26/9/2026): i due bottoni passano da solo
      // SUPERADMIN ad ADMIN o SUPERADMIN, e questa lettura li segue - senza,
      // per l'ADMIN la tendina di «Link Existing Player» resterebbe vuota.
      if (
        chiamanteEAdmin &&
        canonicalRole(user?.role) === "PARENT"
      ) {
        loadPlayers();
      }
    }, [user, chiamanteEAdmin]);

    // «RENEW CHILDREN» — I FIGLI CHE SI POSSONO RINNOVARE DA QUI (cantiere
    // RINNOVO-FIGLI-ADMIN). Tre vagli, nessuno dei quali ricopia la regola:
    //   1. il figlio e' stato LETTO (le voci in errore non si offrono);
    //   2. il suo `guardians` elenca QUESTO genitore: e' la faccia autorevole
    //      del legame, la stessa che il server verifica con `figliDiGenitore`.
    //      Un figlio presente nel solo `linkedProfiles` (facce divergenti)
    //      farebbe fallire l'intera richiesta (403 CHILD_NOT_OWNED): meglio
    //      non offrirlo che offrire una porta murata;
    //   3. il server gli da' TITOLO per l'anno d'iscrizione: `renewableSeasons`
    //      lo contiene (vedi `titoliRinnovo`).
    // Chi ha gia' la tessera dell'anno d'iscrizione non ha titolo (anti-doppione
    // di `ruoliDaRinnovare`), quindi qui non compare: niente liste di
    // non-rinnovati, solo chi si puo' rinnovare adesso.
    const figliDaRinnovare = useMemo(() => {
      if (!Number.isInteger(enrollmentSeason) || !user?.id) return [];

      const idGenitore = String(user.id);

      return linkedProfiles
        .filter(voce => voce && !voce.error && voce.profile)
        .filter(
          voce =>
            Array.isArray(voce.profile.guardians) &&
            voce.profile.guardians.includes(idGenitore)
        )
        .filter(voce =>
          (titoliRinnovo.perId[String(voce.id)] || []).includes(enrollmentSeason)
        )
        .map(voce => ({
          id: String(voce.id),
          nome: `${voce.profile.firstName || ""} ${voce.profile.lastName || ""}`.trim()
        }));
    }, [linkedProfiles, titoliRinnovo, enrollmentSeason, user?.id]);

  // ------------------------------------------------------------------
  // CLUB NOTES (RL-11) — note interne sul membro, riservate agli
  // amministratori. Gruppo 8b della struttura (doc 07 §11.2).
  //
  // ⚠️ Le note NON arrivano col profilo: `GET /users/:id` non le porta e non
  // deve portarle (stanno in una collezione separata, vedi il preambolo delle
  // rotte in server.js). Si chiedono qui, con una lettura propria, che parte
  // SOLO per chi vede i comandi di gestione.
  //
  // ⚠️ Qui non si protegge niente: il gate vero e' sul backend, che risponde
  // 403 a chiunque non sia ADMIN/SUPERADMIN. Questo `if` serve a non offrire
  // una porta murata e a non far partire una lettura destinata al rifiuto.
  //
  // Gli hook stanno qui, sopra il return anticipato del profilo, come gli
  // altri: dopo, React non li vedrebbe piu' su ogni render.
  // ------------------------------------------------------------------
  const puoVedereNote = chiamanteEAdmin;

  const [note, setNote] = useState([]);
  // "spente" | "caricamento" | "pronte" | "errore"
  const [statoNote, setStatoNote] = useState("spente");
  const [nuovaNota, setNuovaNota] = useState("");
  // La nota aperta in modifica: { id, text }, oppure null.
  const [notaInModifica, setNotaInModifica] = useState(null);
  const [notaInCorso, setNotaInCorso] = useState(false);
  const [erroreNote, setErroreNote] = useState("");

  // Rilettura dell'elenco. La chiamano l'apertura della scheda e ogni azione
  // riuscita: le rotte di scrittura tornano la sola nota scritta, non
  // l'elenco da disegnare (stessa ragione di `ricaricaProfilo`).
  const caricaNote = useCallback(async () => {
    if (!idProfilo || !puoVedereNote) return;

    try {
      const risposta = await api.get(`/users/${idProfilo}/notes`);

      // La pagina puo' passare da una persona a un'altra senza smontarsi: una
      // risposta partita per il profilo precedente non deve disegnarsi qui.
      if (idInCorsoRef.current !== idProfilo) return;

      setNote(Array.isArray(risposta?.notes) ? risposta.notes : []);
      setStatoNote("pronte");
    } catch (err) {
      if (idInCorsoRef.current !== idProfilo) return;

      console.error("Failed to load club notes:", err);
      setNote([]);
      setStatoNote("errore");
    }
  }, [idProfilo, puoVedereNote]);

  useEffect(() => {
    // Cambio di persona: si azzera tutto, comprese le bozze in corso. Il testo
    // scritto per un membro non deve ricomparire sulla scheda di un altro.
    setNote([]);
    setNuovaNota("");
    setNotaInModifica(null);
    setErroreNote("");

    if (!idProfilo || !puoVedereNote) {
      setStatoNote("spente");
      return;
    }

    setStatoNote("caricamento");
    caricaNote();
  }, [idProfilo, puoVedereNote, caricaNote]);

  // Una data leggibile. La PWA e' in inglese (CLAUDE.md §3.7), quindi anche il
  // formato: en-AU, come il club. Serve alla firma delle note, ai pagamenti e
  // ai metadati del gruppo 8a — un solo modo di scrivere una data in tutta la
  // scheda.
  const dataBreve = (iso) => {
    const quando = new Date(iso || "");
    return Number.isNaN(quando.getTime()) ? "" : quando.toLocaleDateString("en-AU");
  };

  // Un importo in dollari australiani. Stessa forma di ClubFinance.jsx (lo
  // spazio stretto ` ` fra simbolo e cifre), senza il segno + / − che
  // li' serve alla contabilita' e qui direbbe il falso su una quota.
  const importo = (valore) => {
    const numero = Number(valore);
    if (!Number.isFinite(numero)) return "";
    return (
      "$ " +
      numero.toLocaleString("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  };

  // Se la nota l'ha scritta chi sta guardando. Il confronto e' lo stesso di
  // `eSeStesso` piu' sotto — il backend firma con l'id del DOCUMENTO utente,
  // ma i dati storici confondono id e firebaseUid, e si accettano entrambi.
  //
  // ⚠️ Qui si decide solo COSA MOSTRARE. Il permesso di modificare e
  // cancellare lo verifica il backend, che rifiuta con 403 chiunque non sia
  // l'autore — nemmeno un altro admin o il superadmin.
  const eMiaNota = (nota) =>
    [utenteCollegato?.id, utenteCollegato?.firebaseUid]
      .filter(Boolean)
      .map(String)
      .includes(String(nota?.authorId || ""));

  const aggiungiNota = async () => {
    const testo = nuovaNota.trim();
    if (!testo || notaInCorso) return;

    try {
      setNotaInCorso(true);
      setErroreNote("");

      await api.post(`/users/${idProfilo}/notes`, { text: testo });

      setNuovaNota("");
      await caricaNote();
    } catch (err) {
      console.error("Failed to add club note:", err);
      setErroreNote("Could not save the note. Please try again.");
    } finally {
      setNotaInCorso(false);
    }
  };

  const salvaNotaModificata = async () => {
    if (!notaInModifica || notaInCorso) return;

    const testo = (notaInModifica.text || "").trim();
    if (!testo) return;

    try {
      setNotaInCorso(true);
      setErroreNote("");

      await api.patch(`/users/${idProfilo}/notes/${notaInModifica.id}`, {
        text: testo
      });

      setNotaInModifica(null);
      await caricaNote();
    } catch (err) {
      console.error("Failed to update club note:", err);
      setErroreNote("Could not update the note. Please try again.");
    } finally {
      setNotaInCorso(false);
    }
  };

  const cancellaNota = async (noteId) => {
    if (notaInCorso) return;
    if (!window.confirm("Delete this note? This cannot be undone.")) return;

    try {
      setNotaInCorso(true);
      setErroreNote("");

      // ⚠️ `api.del`, non `api.delete`: il client espone quel nome (api.js).
      await api.del(`/users/${idProfilo}/notes/${noteId}`);

      // Se era la nota aperta in modifica, la modifica non ha piu' oggetto.
      setNotaInModifica(attuale =>
        attuale && attuale.id === noteId ? null : attuale
      );

      await caricaNote();
    } catch (err) {
      console.error("Failed to delete club note:", err);
      setErroreNote("Could not delete the note. Please try again.");
    } finally {
      setNotaInCorso(false);
    }
  };

  // Finche' il profilo non e' arrivato non si disegna nessun campo: meglio il
  // vuoto di un profilo mezzo pieno.
  // Rifiuto o guasto: un messaggio solo, uguale in ogni caso, che non dice se
  // quella persona esista.
  // ⚠️ IL CASO NUOVO DELLA FASE 3 e' proprio questo. Ora che le schede hanno
  // un indirizzo, chiunque puo' digitare `/profile/<id>` di una persona che il
  // backend non gli concede: la risposta e' 403, e finisce qui. La pagina non
  // si rompe e non resta vuota — porta il telaio, quindi la barra utente e il
  // «Back» — e dice una riga sola, la stessa dell'attesa fallita e dell'id
  // inesistente. Il dato lo protegge il server; qui si governa la sola resa.
  if (statoProfilo !== "pronto" || !user) {
    return (
      <HomeShell backTo={tornaIndietro} showSwitch={false}>
        <p className="qpsc-body-text qpsc-body-text--muted">
          {statoProfilo === "caricamento"
            ? "Loading profile…"
            : avvisoProfilo || "This profile is not available."}
        </p>
      </HomeShell>
    );
  }

  // ------------------------------------------------------------------
  // IL CANCELLO DELLA STAGIONE (VP2/F5, decisione 4 del committente).
  //
  // ⚠️ SE L'ANNO OPERATIVO NON SI SA, LA SCHEDA NON SI APRE. Questa pagina
  // dice «ADESSO» — l'anno operativo e nient'altro: le tessere, la squadra,
  // la categoria, Play Football sono tutti letti a quell'anno. Senza l'anno
  // non c'e' una resa parziale onesta: ci sarebbe una scheda che sembra
  // dell'anno in corso e porta invece un miscuglio di annate. Si mostra
  // percio' un avviso solo, dentro il telaio (barra e «Back» restano), e
  // nessun dato anagrafico.
  //
  // ⚠️ IL CASO «ANCORA IN ARRIVO» NON E' UN GUASTO: con `seasonStatus`
  // "loading" la cassettina puo' ancora rispondere, e dire «riprova» a chi
  // sta semplicemente aspettando sarebbe una bugia. Si mostra l'attesa.
  //
  // ⚠️ STA DOPO IL RITORNO DEL PROFILO, non prima: cosi' un 403 continua a
  // rispondere «profilo non disponibile» invece di rivelare, con una frase
  // diversa, che quella persona esiste.
  // ------------------------------------------------------------------
  if (!stagioneLeggibile) {
    return (
      <HomeShell backTo={tornaIndietro} showSwitch={false}>
        <p className="qpsc-body-text qpsc-body-text--muted">
          {/* TESTO PROVVISORIO — doc 07 §11 */}
          {seasonStatus === "loading"
            ? "Loading profile…"
            : "Could not read the club season. Please try again in a moment."}
        </p>
      </HomeShell>
    );
  }

  // ------------------------------------------------------------------
  // LETTURE DI SOLA VISTA. Nessuna di queste scrive alcunché.
  // ------------------------------------------------------------------

  // La domanda sulla disabilita' ha TRE risposte e il documento le porta
  // come true / false / null. E' la stessa lettura del modulo di
  // completamento (HomeIncomplete.jsx, `disabilitaDalDocumento`): solo
  // `true` e' un si', solo `false` e' un no, e tutto il resto — `null`,
  // campo assente, documento vecchio — e' «non dichiarato».
  // ⚠️ `null` NON e' un no: un socio che non ha risposto non va mostrato
  // come persona senza disabilita'.
  const disabilita =
    user.disability && typeof user.disability === "object" ? user.disability : {};

  const testoDisabilita =
    disabilita.has === true
      ? "Yes"
      : disabilita.has === false
      ? "No"
      : "Not specified";

  const wwc = user.wwc && typeof user.wwc === "object" ? user.wwc : {};

  // ⚠️ IL GATE DEL GRUPPO 6 E' CAMBIATO (delta 12 della specifica).
  // Prima era `haWwc` — «il documento porta un numero, una scadenza o un
  // file?» — cioe' un gate SUL DATO. Ora e' «IL TESSERATO E' UN COACH?», un
  // gate SUL RUOLO: il Working with Children Check e' il controllo richiesto
  // a chi lavora con i minori, quindi la sezione appartiene alla scheda di un
  // allenatore anche quando e' ancora vuota (ed e' proprio li' che un admin
  // deve accorgersi che manca).
  // Senza questo cambio, tolta la riga del file (delta 5), un tesserato che
  // avesse SOLO il file caricato avrebbe mostrato una sezione vuota.
  //
  // ⚠️ Il metro e' `hasRole` sul DOCUMENTO APERTO, non su chi guarda: legge
  // `role` di primo livello PIU' i context ACTIVE, e traduce MANAGER / TD /
  // MANAGERTD in COACH (vocabolario di access.js). Un coach del modello
  // storico non perde la sezione.
  const soggettoECoach = hasRole(user, "COACH");

  // IL GENITORE E BASTA (addendum B, P2 — regola A1 del committente).
  //
  // Due sezioni non appartengono alla scheda di chi nel club e' SOLO un
  // genitore: «Inclusion & Wellbeing» (lingua di casa, scuola, disabilita' —
  // domande che il club fa a chi scende in campo) e
  // «Uniforms» (un genitore non ha divise: `righeDivise` gli torna comunque
  // vuoto, e la sezione stampava «No uniform items for this member.» su ogni
  // scheda di genitore). Non si mostrano vuote: non si mostrano.
  //
  // ⚠️ STESSO METRO DEGLI ALTRI GATE DI RUOLO DI QUESTA SCHEDA — `hasRole`
  // sul DOCUMENTO APERTO, non su chi guarda: `role` di primo livello PIU' i
  // context ACTIVE, col vocabolario di access.js (MANAGER/TD/MANAGERTD =
  // COACH, CHILD = PLAYER). E' la forma variadica gia' usata dall'app per la
  // stessa domanda (`isPlayFootballEligible`, utils/playFootball.js).
  //
  // ⚠️ «SOLO» VUOL DIRE SOLO: il genitore che ALLENA, o che gioca, o che e'
  // un amministratore, continua a vedere entrambe le sezioni come oggi — e
  // in un club il genitore-allenatore e' ordinario. Chi non e' genitore
  // affatto non e' toccato da questa riga.
  const soloGenitore =
    hasRole(user, "PARENT") &&
    !hasRole(user, "PLAYER", "COACH", "ADMIN", "SUPERADMIN");

  // La richiesta «gioco/alleno anch'io» (RL-7d-2). `requestedContext` e' una
  // STRINGA SINGOLA: "PLAYER", "COACH" oppure `null` — non un elenco, perche'
  // una persona chiede un solo contesto in piu' (server.js, dove il
  // costruttore riduce a `null` tutto cio' che non e' una di quelle due
  // parole). La grafia salvata e' sempre maiuscola, ma qui si legge in modo
  // tollerante — `trim().toUpperCase()` — perche' costa una riga e mette al
  // riparo dai documenti scritti a mano.
  //
  // ⚠️ Non e' un ruolo e non concede nulla: e' cio' che la persona CHIEDE di
  // essere.
  const richiestaPendente = (() => {
    const grezzo = String(user.requestedContext || "").trim().toUpperCase();
    return grezzo === "PLAYER" || grezzo === "COACH" ? grezzo : null;
  })();

  const etichettaRichiesta = richiestaPendente === "COACH" ? "Coach" : "Player";

  // `enrolled` non si ricalcola qui: lo CALCOLA il server e il frontend lo
  // legge, con la convenzione «CAMPO ASSENTE = COMPLETO» che vive in un
  // posto solo — `isEnrolled` (access.js, `user.enrolled !== false`), la
  // stessa funzione con cui il cancello decide il dirottamento a
  // /home/incomplete (RequireRole.jsx). Riusarla, invece di riscrivere il
  // confronto, e' cio' che garantisce che l'admin veda ESATTAMENTE la scheda
  // che il cancello considera incompleta.
  const schedaCompleta = isEnrolled(user);

  // L'ETA' COMPIUTA, accanto alla data di nascita (delta 11 della specifica).
  // `etaCompiuta` torna `null` se la data non e' leggibile o non esiste nel
  // calendario: in quel caso si mostra la sola data, senza indovinare.
  const eta = etaCompiuta(user.dob, oggiAPerth());

  // E' UN MINORE, questa scheda? Guardia di SOLA VISIBILITA' del bottone
  // «Send sign-in link» (cantiere LINK-ACCESSO, F2): il gate vero e' il 400
  // del backend (`eMinore` in POST /users/:id/send-signin-link). Stesso metro
  // del server — il campo `isMinor` OPPURE il conto sulla data di nascita —
  // col conto gia' fatto qui sopra (`etaCompiuta`, stessa regola di calendario
  // di `isMinorDaDob`). Il frontend non ha una funzione «minore» propria
  // (access.js e roleUtils.js non ne portano): non se ne inventa una, si
  // compongono i due pezzi che la pagina ha gia'. Si sbaglia nel verso che
  // protegge di piu': basta che uno dei due dica «minore».
  const eMinoreQuestaScheda =
    user.isMinor === true || (eta !== null && eta < 18);

  // IL GENERE, PER ESTESO (VP2/F4a, decisione 9 del committente).
  //
  // ⚠️ A SCHERMO SI LEGGE LA PAROLA, NEI DATI STA LA LETTERA. Il documento
  // porta «M»/«F» (rotte d'iscrizione nuove) oppure «Male»/«Female»
  // (importazione storica): la canonizzazione e' quella unica dell'app
  // (`genereCanonico`), qui non se ne scrive una seconda, e l'etichetta viene
  // dal vocabolario `GENERI`, lo stesso di ogni tendina del genere.
  //
  // ⚠️ IL VALORE NON TRADUCIBILE SI MOSTRA GREZZO E INVARIATO: un «Other», o
  // un refuso, resta quello che e'. Non si nasconde — l'amministratore deve
  // poterlo vedere per correggerlo da «Edit Member» — e non si riscrive:
  // questa e' una vista, e una vista non aggiusta i dati di nessuno.
  const genereEsteso = (() => {
    const canonico = genereCanonico(user.gender);
    if (!canonico) return user.gender;

    const voce = GENERI.find((g) => g.valore === canonico);
    return voce ? voce.etichetta : user.gender;
  })();

  const ruoliChiamante = getActiveRoles(utenteCollegato);
  const chiamanteAttivo =
    (normalizeRole(utenteCollegato?.status) || "ACTIVE") === "ACTIVE";

  const eSeStesso = [utenteCollegato?.firebaseUid, utenteCollegato?.id]
    .filter(Boolean)
    .map(String)
    .includes(String(user.id));

  // ------------------------------------------------------------------
  // IL PUNTO DI VISTA (specifica §«Viewpoints», doc 07 §11.4).
  //
  // Tre livelli d'accesso, gia' nel server: A pieno (sé, tutore, admin/SA),
  // B ridotto (coach della propria squadra), C niente (403). Vince il livello
  // piu' alto. Qui interessa distinguere UNA cosa sola: se chi guarda e' un
  // COACH nell'esercizio del ramo di squadra, perche' a lui tre gruppi non si
  // disegnano — 1b Identity Documents (che il server gli ha gia' tagliato),
  // 4 Active Roles e 8a Record (dato ORGANIZZATIVO, non sensibile: la
  // regola-cardine del §11.4 vieta di nascondere a schermo il sensibile, non
  // il rumore).
  //
  // ⚠️ SI RICAVA PER SOTTRAZIONE, e non e' una scorciatoia: chi non e'
  // admin, non e' sé stesso e non e' un tutore del soggetto NON RICEVEREBBE
  // AFFATTO IL DOCUMENTO se non passasse dal ramo coach — il server risponde
  // 403 (livello C) e questo componente mostra la riga unica di indisponi-
  // bilita'. Dunque, arrivati a disegnare, «non A» significa «B», cioe' coach.
  // Ricalcolare qui l'appartenenza di squadra sarebbe un SECONDO metro
  // rispetto a `squadreDelCoach` del server, destinato a divergerne.
  //
  // ⚠️ STA QUI, SOPRA I PERMESSI, e non piu' sotto: `puoCambiareFoto` ha ora
  // bisogno di sapere se chi guarda e' il TUTORE del soggetto, e il metro
  // dev'essere UNO SOLO — questo. L'ordine delle dichiarazioni e' l'unica
  // ragione dello spostamento: il corpo non e' cambiato.
  // ------------------------------------------------------------------

  // ⚠️ Il test del tutore e' quello del server (`eProprietarioOTutore`,
  // server.js): i `guardians` del soggetto contengono un
  // identificativo di chi guarda. Si accettano `id` e `firebaseUid` perche' i
  // dati storici li confondono, come gia' in `eSeStesso`.
  const identificativiChiamante = [utenteCollegato?.id, utenteCollegato?.firebaseUid]
    .filter(Boolean)
    .map(String);

  // ⚠️ NON ARCHIVIATO, e non «attivo»: e' la condizione ESATTA che il server
  // mette al ramo tutore (server.js, `if (statusChiamante ===
  // "ARCHIVED") return false`). La tutela e' un potere su dati altrui e decade
  // con l'archiviazione; ma NON si pretende ACTIVE, perche' una famiglia
  // appena iscritta e' PENDING per intero — genitore compreso — e deve poter
  // agire lo stesso. Scriverci `chiamanteAttivo` sarebbe stato piu' severo del
  // server, e avrebbe tolto la foto del figlio proprio al genitore che si e'
  // appena iscritto.
  const chiamanteNonArchiviato =
    (normalizeRole(utenteCollegato?.status) || "ACTIVE") !== "ARCHIVED";

  const chiamanteETutore =
    chiamanteNonArchiviato &&
    Array.isArray(user.guardians) &&
    user.guardians.some(
      voce =>
        typeof voce === "string" && identificativiChiamante.includes(voce.trim())
    );

  const vistaCoach = !chiamanteEAdmin && !eSeStesso && !chiamanteETutore;

  // ⚠️ LA FOTO NON E' UN DATO DA CHIUDERE COL SELF-SERVICE: E' L'AVATAR
  // (correzione di rotta del committente, 22/8/2026, che annulla la riduzione
  // introdotta poche ore prima dal delta 7). La fase 4a aveva ristretto il
  // comando al solo ADMIN/SA; qui il ramo `eSeStesso` torna, e accanto entra
  // il ramo TUTORE, che nella scheda mancava.
  //
  // ⚠️ E' ORA LO SPECCHIO ESATTO DI `POST /upload` (server.js):
  // sé stessi — a qualunque status, di proposito, perche' chi si e' appena
  // iscritto nasce PENDING e deve poter caricare la propria foto — OPPURE il
  // TUTORE del bersaglio (non archiviato) OPPURE un ADMIN/SUPERADMIN ATTIVO.
  // Il ramo tutore e' il piu' necessario di tutti: la foto di un minore la
  // carica il genitore, perche' il minore non ha un account con cui farlo.
  //
  // ⚠️ Qui non si protegge nulla — il gate vero e' il 403 del server: questa
  // e' la sola resa a schermo, e serve a non offrire una porta murata ne' a
  // nascondere una porta aperta. Se le due regole divergono, comanda il
  // backend. Il COACH resta fuori da entrambe: non compare in nessuno dei tre
  // rami, ne' qui ne' sul server.
  const puoCambiareFoto =
    eSeStesso ||
    chiamanteETutore ||
    (chiamanteAttivo &&
      (ruoliChiamante.includes("ADMIN") || ruoliChiamante.includes("SUPERADMIN")));

  // Chi puo' CANCELLARE il profilo aperto. Il permesso (`chiamanteEAdmin`)
  // dice che cosa si puo' fare; questo dice SU CHI, ed e' la disuguaglianza
  // STRETTA del backend (`puoAgireSuBersaglio`, server.js), qui
  // riusata dalla sede unica dei ruoli invece di essere riscritta.
  //
  // ⚠️ Non protegge nulla — il gate vero e' il 403 del server: serve a non
  // offrire una porta murata. Copre in un colpo solo i tre casi in cui il
  // server rifiuta comunque: sé stessi, un altro ADMIN, un SUPERADMIN.
  const puoCancellare = puoAgireSuBersaglio(utenteCollegato, user);

  const handleCaptureSelfie = async () => {
    try {
      if (!webcamRef.current) return;

      setUploadingSelfie(true);

      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) {
        alert("Failed to capture image.");
        return;
      }

      const blob = await fetch(imageSrc).then(res => res.blob());
      const file = new File([blob], "selfie.jpg", { type: "image/jpeg" });

      const fd = new FormData();
      fd.append("photo", file);
      fd.append("userId", user.id);

      await api.postForm("/upload", fd);

      // ⚠️ LA FOTOCAMERA SI CHIUDE QUI, PRIMA DELLA RILETTURA (P9, ratificato
      // dal capomastro). L'upload è riuscito: la chiusura non deve più
      // dipendere dall'esito di una lettura.
      setShowCamera(false);

      // 🔄 aggiorna utente — con la RILETTURA DI CASA, non con una GET nuda.
      // La `api.get` che stava qui non aveva un `catch` proprio: se falliva,
      // l'esecuzione saltava al `catch` qui sotto e la persona leggeva
      // «Failed to upload selfie.» per una foto che ERA STATA CARICATA.
      //
      // ⚠️ Chiamata SENZA argomento, cioè `svuotaSuRifiuto: false`: è un uso
      // POST-AZIONE — sotto c'è una scheda piena, e sostituirla con «This
      // profile is not available.» per un guasto di sola lettura direbbe il
      // falso su un'azione andata a buon fine.
      //
      // ⚠️ PREZZO DICHIARATO di questa forma: se la rilettura fallisce non
      // compare NESSUN segnale — la foto è salita, la scheda mostra ancora
      // quella vecchia. È il male minore rispetto al messaggio che diceva il
      // falso, ed è la forma ratificata dal capomastro. A verbale in P9.
      await ricaricaProfilo();
      propagaAggiornamento();

    } catch (err) {
      console.error("Selfie upload failed:", err);
      alert("Failed to upload selfie.");
    } finally {
      setUploadingSelfie(false);
    }
  };

  // Scarica un documento riservato (id-document / other-document).
  //
  // Gli endpoint richiedono l'header Authorization, che un semplice <a href>
  // non puo' allegare: si scarica quindi via fetch autenticata e si consegna
  // al browser il blob ottenuto.
  const downloadDocument = async (endpoint, fileName) => {
    try {
      const res = await fetch(
        `${API_ROOT}/users/${user.id}/${endpoint}`,
        {
          credentials: "include",
          headers: await authHeaders(),
        }
      );

      if (!res.ok) {
        console.error("Document download failed:", endpoint, res.status);
        alert("Failed to open the document.");
        return;
      }

      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = fileName || endpoint;
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Il rilascio immediato interromperebbe il download in alcuni browser.
      setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
    } catch (err) {
      console.error("Document download failed:", endpoint, err);
      alert("Failed to open the document.");
    }
  };

  // Nome del file foto mostrato nella scheda. photoUrl e' un URL Storage
  // con il percorso codificato (users%2F<id>%2Fprofile.jpg): si decodifica
  // per mostrare solo il nome del file.
  const nomeFileFoto = (() => {
    const grezzo = String(localUser?.photoUrl || "");
    if (!grezzo) return "";
    try {
      return decodeURIComponent(grezzo.split("?")[0]).split("/").pop();
    } catch {
      return grezzo.split("/").pop();
    }
  })();

  // Apre la foto profilo. Lo Storage e' chiuso in lettura: il file arriva
  // dal backend con fetch autenticata, come i documenti.
  const downloadPhoto = async () => {
    try {
      const res = await fetch(`${API_ROOT}/users/${user.id}/photo`, {
        credentials: "include",
        headers: await authHeaders(),
      });

      if (!res.ok) {
        console.error("Photo download failed:", res.status);
        alert("Failed to open the photo.");
        return;
      }

      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = nomeFileFoto || "photo.jpg";
      document.body.appendChild(link);
      link.click();
      link.remove();

      setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
    } catch (err) {
      console.error("Photo download failed:", err);
      alert("Failed to open the photo.");
    }
  };

  // Archivia la richiesta «gioco/alleno anch'io»: la CHIUDE, non la accoglie.
  //
  // ⚠️ IL CORPO PORTA UN CAMPO SOLO, `requestedContext: null`, e nient'altro:
  // niente `role`, niente `contexts`, niente `status`, niente `team`.
  // Il backend, per quel campo, fa una cosa sola — lo porta a `null`: non
  // assegna ruoli, non tocca i contexts, non fa scattare alcun ricalcolo.
  // Accodare qui un altro campo trasformerebbe un'archiviazione in una
  // concessione: non si fa.
  //
  // ⚠️ CHE COSA NON FA: non concede il contesto richiesto. La concessione
  // vera si scrive altrove — `PUT /admin/users/:id/contexts`, cioe' la
  // pagina dei contexts. Di qui l'etichetta «Mark as handled», che non
  // promette nulla.
  const handleArchiviaRichiesta = async () => {
    if (!chiamanteEAdmin) {
      alert("You do not have permission to handle this request.");
      return;
    }

    if (
      !window.confirm(
        "Mark this role request as handled? The request will be cleared from the profile. This does NOT grant any role."
      )
    ) {
      return;
    }

    try {
      setArchiviandoRichiesta(true);

      await api.put(`/users/${user.id}`, { requestedContext: null });

      // La scheda si rilegge, come fanno gli altri comandi: la risposta del
      // PUT porta i soli campi scritti, non il documento da disegnare.
      await ricaricaProfilo();

      propagaAggiornamento();
    } catch (err) {
      console.error("Failed to clear requested context:", err);
      alert("Failed to update the request. Please try again.");
    } finally {
      setArchiviandoRichiesta(false);
    }
  };

  // «Send sign-in link» (cantiere LINK-ACCESSO, F2). Il SUPERADMIN fa
  // spedire al socio, dal backend, un link d'accesso Firebase alla casella
  // della scheda: il link lo genera e lo imbusta il server, e QUI NON ARRIVA
  // MAI — la risposta e' un `{ sent: true }` e basta. Calco di
  // `handleArchiviaRichiesta`: `window.confirm` (spedire un link non e'
  // irreversibile: niente parola digitata), `api.post`, `alert` per l'esito.
  //
  // ⚠️ Nel catch si stampa il SOLO `err.status`, non l'errore intero:
  // `console.error(err)` stamperebbe anche `err.body`, e la prassi anti-fuga
  // di questo cantiere e' non mettere in console il corpo di una risposta
  // che parla di un link (referto R0 Q5c/Q7a), anche se per come e' scritta
  // la rotta il corpo non lo contiene.
  const handleSendSigninLink = async () => {
    if (!window.confirm("Send a new sign-in link to this member's email address?")) return;
    try {
      setInviandoLink(true);
      await api.post(`/users/${user.id}/send-signin-link`);
      alert("Sign-in link sent.");
    } catch (err) {
      console.error("Failed to send sign-in link:", err && err.status);
      alert("Could not send the sign-in link. Please try again.");
    } finally {
      setInviandoLink(false);
    }
  };

  // «Renew children» (cantiere RINNOVO-FIGLI-ADMIN). Calco del pannello di
  // EnrolNextSeason.jsx — spunte, riscontro, figli non inclusi — ma NON il
  // componente: quello e' cablato sull'utente collegato, ha la riga «You» e
  // rilegge il profilo di chi guarda. Qui il genitore non si rinnova mai, e
  // dopo l'invio si rilegge la scheda APERTA (il genitore), non l'admin.
  //
  // Le spunte partono tutte accese, come nel pannello del socio: la lista
  // contiene gia' solo chi ha titolo.
  const apriRinnovoFigli = () => {
    setSceltiRinnovo(figliDaRinnovare.map(figlio => figlio.id));
    setEsitoRinnovo(null);
    setShowRenewChildren(true);
  };

  const chiudiRinnovoFigli = () => {
    setShowRenewChildren(false);
    setEsitoRinnovo(null);
    setSceltiRinnovo([]);
  };

  const spuntaRinnovo = (id) => {
    setSceltiRinnovo(elenco =>
      elenco.includes(id) ? elenco.filter(v => v !== id) : elenco.concat(id)
    );
  };

  const confermaRinnovoFigli = async () => {
    // Si manda solo cio' che e' ancora in lista: una spunta rimasta su un
    // figlio uscito dalla lista (ricarica nel frattempo) non parte.
    const scelti = sceltiRinnovo.filter(id =>
      figliDaRinnovare.some(figlio => figlio.id === id)
    );

    if (scelti.length === 0 || !user?.id) return;

    // I nomi si fotografano PRIMA dell'invio: dopo la rilettura i figli
    // rinnovati escono dalla lista, e la frase dei non inclusi li cerca qui.
    const nomiPrima = figliDaRinnovare;

    setInvioRinnovo(true);
    setEsitoRinnovo(null);

    try {
      // ⚠️ ELENCO CHIUSO: solo gli id dei figli spuntati. Il genitore e' in
      // URL; ruolo, anno e status li decide il server.
      const risposta = await api.post(
        `/admin/users/${encodeURIComponent(user.id)}/renew-children`,
        { children: scelti }
      );

      const nate = Array.isArray(risposta && risposta.renewed) ? risposta.renewed : [];
      const anno = (risposta && risposta.enrollmentSeason) || enrollmentSeason;

      const idSaltati = (Array.isArray(risposta && risposta.skipped) ? risposta.skipped : [])
        .map(voce => (typeof voce === "string" ? voce : voce && voce.id));
      const nomiSaltati = nomiPrima
        .filter(figlio => idSaltati.includes(figlio.id))
        .map(figlio => figlio.nome || "A child's record");

      setEsitoRinnovo(
        nate.length > 0
          ? {
              tipo: "ok",
              testo: `Enrollment for ${anno} requested for ${nate.length} ${
                nate.length === 1 ? "child" : "children"
              }. Approve it from Team Assignment as usual.`,
              nonInclusi: nomiSaltati.length
                ? `Not included: ${nomiSaltati.join(", ")}.`
                : ""
            }
          : {
              tipo: "vuoto",
              testo: `Nothing new to enroll for ${anno}.`
            }
      );

      // Si rilegge la scheda del GENITORE: senza svuotare su rifiuto, perche'
      // il rinnovo e' gia' avvenuto. La rilettura riaccende anche la lettura
      // dell'elenco (titoli aggiornati).
      await ricaricaProfilo();
    } catch (err) {
      const stato = err && err.status;
      let testo;

      if (stato === 409 || stato === 403 || stato === 400) {
        // I testi del server sono gia' in inglese e scritti per chi legge:
        // iscrizioni chiuse, stagione illeggibile, figlio non di questo
        // genitore (CHILD_NOT_OWNED, «Nothing was renewed»).
        const dalServer = messaggioDelServer(err);
        // Il 403 d'autorita' risponde il nudo «Forbidden»: non e' una frase.
        testo =
          dalServer && dalServer !== "Forbidden"
            ? dalServer
            : "The renewal could not be completed. Nothing was renewed.";
      } else if (!stato) {
        testo = "Could not reach the server. Please check your connection and try again.";
      } else {
        testo = "Something went wrong. Please try again in a moment.";
      }

      console.error("Renew children failed:", stato);
      setEsitoRinnovo({ tipo: "errore", testo });
    } finally {
      setInvioRinnovo(false);
    }
  };

  // DELETE member
  const handleDelete = async () => {
    // `puoCancellare` accompagna il ruolo: il bottone non si disegna quando il
    // server rifiuterebbe, e il gestore rifiuta gli stessi casi anche se lo si
    // raggiungesse per altra via. E' difesa in profondita', non il gate:
    // quello e' il 403 del backend: la guardia `puoAgireSuBersaglio` dentro
    // `DELETE /users/:id` (`backend/server.js` — citata per contenuto e non
    // per numero di riga, che slitta a ogni fetta).
    if (!chiamanteEAdmin || !puoCancellare) {
      alert("You do not have permission to delete this member.");
      return;
    }
    if (!window.confirm("Are you sure you want to delete this member?")) return;
    const double = window.prompt('Type "DELETE" to confirm:');
    if (double !== "DELETE") {
      alert("Cancelled");
      return;
    }
    try {
      await api.del(`/users/${user.id}`);
      alert("Member deleted from JSON and Firebase!");
      // Cancellata la persona, questa pagina non ha piu' un soggetto: si
      // torna da dove si e' venuti.
      tornaIndietro();
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete member. Please try again.");
    }
  };

  // ------------------------------------------------------------------
  // I DERIVATI DELLA VISTA, calcolati una volta e letti dalle sezioni.
  // ------------------------------------------------------------------

  const nomeCompleto = [user.firstName, user.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  // LO STATO IN TESTATA E' QUELLO DELL'ANNO OPERATIVO (decisione del
  // committente, 15/10/2026), a tre vie:
  //  - AMMINISTRATORE → lo `status` di persona, come prima: le cariche
  //    amministrative non portano l'anno. Il predicato e' quello di User List
  //    (`eAmministratore`, UsersList.jsx: `hasRole(user, "ADMIN",
  //    "SUPERADMIN")`), richiamato qui senza copiarne una funzione;
  //  - altrimenti, CON TESSERE DELL'ANNO OPERATIVO → la regola condivisa
  //    `statoDelleTessere` (utils/squadre.js, la stessa di User List e Team
  //    Assignment) su `tessereOperative`, l'insieme in ogni stato gia'
  //    calcolato fra gli hook. Le tessere ci sono, quindi il ripiego non entra
  //    in gioco: `null`, neutro;
  //  - SENZA TESSERE DELL'ANNO → `null`: la pastiglia TACE. Lo `status` di
  //    persona e' lo specchio di un'altra annata e direbbe il falso.
  const statoSoggetto = hasRole(user, "ADMIN", "SUPERADMIN")
    ? normalizeRole(user.status) || "ACTIVE"
    : tessereOperative.length > 0
    ? statoDelleTessere(tessereOperative, null)
    : null;

  // LE TESSERE RESE IN «Active Roles» sono quelle dell'ANNO OPERATIVO (piu' le
  // cariche amministrative, che anno non hanno): il calcolo sta fra gli hook,
  // qui si legge soltanto. Prima erano TUTTE le tessere di TUTTE le annate, con
  // un confronto di status CRUDO che faceva sparire le storiche `"Active"`.
  const contestiAttivi = tessereOperative;

  // GRUPPO 3 — i figli. Il cancello di VISTA chiede se la persona POSSIEDE il
  // ruolo PARENT — lo stesso metro di `soloGenitore` (`hasRole` sul documento
  // aperto: `role` di primo livello o context ACTIVE, canonico) — e non piu'
  // quale sia il suo «ruolo attivo» (D-17): cosi' il genitore che allena, o
  // che gioca, vede i suoi figli come il genitore e basta. Non coincide col
  // cancello di CARICO piu' sopra, che resta sul solo `role` di primo livello.
  const mostraFigli = hasRole(user, "PARENT") && linkedProfiles.length > 0;

  const mostraTutori = guardianProfiles.length > 0;

  // GRUPPO 5b — le righe delle divise. Il criterio NON VIVE PIU' QUI: lo
  // decide la sede unica `tipiDivisaSpettanti` (`utils/uniforms.js`), la
  // stessa che usa la pagina di distribuzione. Questa scheda ne teneva una
  // copia, e la copia era ASIMMETRICA (difetto U-Q9): la SQUADRA la prendeva
  // dalla tessera dell'anno, il RUOLO ancora dal documento
  // (`canonicalRole(user.role)`). Con la sede unica ENTRAMBI vengono dalle
  // TESSERE dell'anno operativo: chi ha una tessera COACH quest'anno riceve
  // le divise dell'allenatore anche se il documento dice altro, e chi non ce
  // l'ha piu' non le riceve. E' la correzione voluta (UNIFORMS/D1).
  //
  // ⚠️ LE TESSERE SI PASSANO GIA' FILTRATE SULL'ANNO: `tipiDivisaSpettanti`
  // non conosce l'anno e non deve conoscerlo (contratto della Fetta B).
  // `tessereAttiveOperative` e' esattamente l'insieme che alimentava squadra
  // e divise anche prima — le sole tessere ACTIVE dell'anno operativo.
  //
  // ⚠️ LE RIGHE SONO I CAPI ATTIVI DELLA LISTA DELL'ANNO, IN ORDINE DI LISTA
  // (UNIF3-8, calco di `UniformDistribution.jsx`): la sede unica della
  // spettanza torna un INSIEME di id, che ordine non ha; si scorre la lista
  // dei capi del catalogo (`items`, ordinata per `order` dentro `capiAttivi`)
  // e si tengono i capi che spettano. Cosi' la scheda mostra gli stessi capi,
  // nello stesso ordine e con gli stessi nomi della pagina di distribuzione:
  // un capo SPENTO non compare (anche se un array del catalogo lo cita
  // ancora), un capo NUOVO compare, un capo RINOMINATO porta la label nuova.
  // Finche' la lista non e' salvata (`items` null) il ripiego sono gli otto
  // storici — «Polo-Shirt» compreso, che la copia locale MONCA di questo file
  // non elencava affatto (difetto U-Q3) — nello stesso ordine di sempre.
  // `righeDivise` e' un array di CAPI ({ id, label, hasSize, active, order }),
  // non di stringhe: l'id e' la chiave del dato, la label la sola cosa che si
  // legge. Gli array del catalogo parlano per id, quindi `tipiSpettanti` non
  // cambia. Con `config` nullo (catalogo non arrivato, 404, 409) nessuna
  // riga, come nella pagina.
  const tipiSpettanti = tipiDivisaSpettanti(tessereAttiveOperative, config);

  const capi = config ? capiAttivi(capiDelCatalogo(config.items)) : [];

  const righeDivise = capi.filter(capo => tipiSpettanti.has(capo.id));

  // LE CONSEGNE DELL'ANNO OPERATIVO (UNIFORMS-ANNO/Fetta 3, decisione A del
  // committente): la scheda mostra «adesso», e le divise seguono catalogo
  // e tessere, che gia' leggono l'operativo. La sede
  // unica sceglie fra la fetta `uniformsSeasons[anno]` e il piatto (solo 2026
  // non battezzato); con l'anno ignoto rende `{}`, e la scheda comunque non
  // si apre (`stagioneLeggibile`). Sola lettura: nessuna scrittura da qui.
  const consegneOperative = consegneDellAnnata(user, annoOperativo);

  // GRUPPO 7 — le quote.
  //
  // ⚠️ IL GATE E' IL RUOLO DI CHI GUARDA, NON LA PRESENZA DEL DATO (RC-1
  // della revisione di fase 4a, chiusa qui). Prima era `quote &&`, cioe' «la
  // sezione esiste se il documento porta un blocco fees»: la stessa asimmetria
  // che il delta 12 aveva gia' corretto sul WWC, rimasta in piedi qui.
  // Su un documento STORICO senza blocco `fees` — che i documenti nuovi hanno
  // sempre, ma i vecchi no — l'admin non vedeva affatto la card, quindi non
  // aveva dove accorgersi che le quote mancano ne' dove intervenire: la
  // sezione taceva esattamente nel caso in cui aveva piu' da dire.
  //
  // ⚠️ PER GLI ALTRI NON CAMBIA NULLA, e non e' un caso: `fees` resta un
  // TAGLIO DEL SERVER (fase 2, su `GET /users/:id` e `GET /users?uid=`), e il
  // §11.4 vuole che un «non vede» sensibile sia proprio quello. Qui si sceglie
  // solo SE DISEGNARE la card a chi il dato lo riceve gia'.
  //
  // ⚠️ `chiamanteEAdmin` e' il metro unico del file (possesso del ruolo), e
  // non pretende lo status ACTIVE che il server chiede per consegnare le
  // quote. Un admin non attivo vedrebbe quindi la card con i soli segnaposto:
  // nessun dato in piu' — il server non gliene manda — e la stessa resa di un
  // documento senza quote. Introdurre qui un secondo metro per questo solo
  // caso costerebbe piu' di quanto valga.
  //
  // `quote` resta `null` quando il blocco non c'e': da qui in giu' non e' piu'
  // il gate della sezione, e' il modo per distinguere «zero dollari» da «nessun
  // dato», che a schermo sono due cose diverse.
  //
  // ⚠️ RD-161: LE QUOTE DELL'ANNO OPERATIVO, lette con la sede unica
  // `quoteDellAnnata` (utils/quote.js), come le divise qui sopra e come la
  // finestra Payments. Prima si leggeva il campo piatto `fees`, fermo all'8/9:
  // un pagamento registrato dopo non compariva. `quoteDellAnnata` rende
  // sempre un record (vuoto se l'annata non ha quote); «nessun dato» e' il
  // record che non porta nulla — nessun campo oltre ai `payments` forzati, e
  // nessun pagamento — e resta `null` come prima.
  const recordQuote = quoteDellAnnata(user, annoOperativo);
  const quote =
    Object.keys(recordQuote).some((k) => k !== "payments") ||
    recordQuote.payments.length > 0
      ? recordQuote
      : null;
  const pagamenti = Array.isArray(quote?.payments) ? quote.payments : [];

  // ------------------------------------------------------------------
  // PLAY FOOTBALL — LA SEDE PER-ANNATA (VP2/F3, decisione 7 del committente).
  //
  // ⚠️ SI LEGGE `playFootballSeasons[<anno operativo>]`, NON PIU' il campo
  // `playFootball` di primo livello. Quello e' la sede vecchia: dice una cosa
  // sola, senza annata, e su una persona iscritta l'anno scorso e non
  // quest'anno affermava «Yes» sotto un'intestazione che parla di adesso.
  //
  // ⚠️ NESSUN RIPIEGO ALLA SEDE VECCHIA (decisione 8 del cantiere PFA): un
  // lettore migrato che, non trovando l'annata, tornasse al campo senz'anno
  // rimetterebbe in circolo proprio il dato che la migrazione ha smesso di
  // scrivere. Annata assente vuol dire «non registrato quest'anno», e si
  // scrive «No».
  //
  // ⚠️ LA CHIAVE SI CERCA COL METRO DELL'ANNO, non con `[String(anno)]`: il
  // backend scrive chiavi stringa, ma il documento e' dato altrui e una
  // chiave numerica non deve far sparire il dato. In SOLA LETTURA: qui non si
  // scrive nulla.
  // ------------------------------------------------------------------
  const mappaPlayFootball =
    user.playFootballSeasons &&
    typeof user.playFootballSeasons === "object" &&
    !Array.isArray(user.playFootballSeasons)
      ? user.playFootballSeasons
      : null;

  const chiaveAnnataPlayFootball = mappaPlayFootball
    ? Object.keys(mappaPlayFootball).find(
        (chiave) => annoDiLista(chiave) === annoOperativo
      )
    : undefined;

  // ⚠️ Serve la DOMANDA, non solo il valore: dove l'annata non c'e' affatto,
  // un `feePaidByClub` letto dal vuoto vale `undefined`, e stamparlo come
  // «No» sarebbe affermare che il club non ha pagato — cosa che il documento
  // non dice. `registered` invece si dichiara sempre (vedi sopra).
  const vocePlayFootball =
    chiaveAnnataPlayFootball === undefined
      ? null
      : mappaPlayFootball[chiaveAnnataPlayFootball];

  // ⚠️ CHI NON E' IDONEO NON HA LA RIGA — non «ha No»: Play Football e' la
  // registrazione federale dei tesserati, e un genitore o un amministratore
  // puro non ci entrano affatto. La definizione dell'idoneita' e' unica in
  // tutta l'app (`isPlayFootballEligible`): qui si chiama, non si riscrive.
  const idoneoPlayFootball = isPlayFootballEligible(user);

  // Le proprieta' comuni a ogni intestazione di sezione: si passano una volta
  // sola invece di ripeterle tredici volte.
  const propsSezione = { aperte: descrizioniAperte, onApri: apriDescrizione };

  return (
    <HomeShell backTo={tornaIndietro} showSwitch={false}>
      {/* ============================================================
          TESTATA (doc 07 §11.2): foto, nome, stato, «Minor», pastiglia
          categoria. IL RUOLO NON STA QUI: e' nel gruppo 5a.
          ============================================================ */}
      <header className="qpsc-vp-head">
        {/* La foto arriva dal backend con fetch autenticata: lo Storage
            e' chiuso in lettura (storage.rules). Vedi AuthAvatar. */}
        <AuthAvatar
          userId={localUser?.id}
          photoKey={localUser?.photoUrl || ""}
          name={nomeCompleto}
          alt={nomeCompleto || "Member"}
          className="qpsc-vp-head__photo"
          fallbackSrc={avatarPlaceholder}
        />

        {/* §3.1: il titolo di pagina e' la classe CONDIVISA del telaio —
            centrato, XXL, rosso — e qui il titolo della pagina e' la
            persona. Nessuna dimensione nuova, nessun colore nuovo. */}
        <h1 className="qpsc-page-title">{nomeCompleto || "Member"}</h1>

        {/* L'ANNO DI QUESTA SCHEDA (VP2/F1, decisione 1 del committente).
            ⚠️ Questa pagina mostra «ADESSO» — l'anno OPERATIVO del club — e
            non ha ne' selettore ne' storico: senza l'anno scritto, chi guarda
            non ha modo di sapere a quale stagione si riferiscano le tessere,
            la squadra, le quote. La pagina non si apre affatto quando l'anno
            non si sa, quindi qui c'e' sempre un intero.
            ⚠️ TESTO NUDO, di proposito: nessuna pastiglia, nessun colore,
            nessuna classe nuova. La forma la decide la passata di veste sul
            doc 07 §11, non questo cantiere. */}
        {/* TESTO PROVVISORIO — doc 07 §11 */}
        <p className="qpsc-body-text qpsc-body-text--muted">
          {`Season ${annoOperativo}`}
        </p>

        {/* ⚠️ I TRE SEGNI SONO PASTIGLIE, tutte e tre (incarico di fase 4b,
            punto 4). La FORMA e' `.qpsc-pill`, la classe condivisa del §2
            che vive in AdminTools.css: qui si aggiunge solo il COLORE, che
            il §2 non prevede perche' stato e «Minor» non sono categorie.
            Nessuna forma nuova, nessuna copia della pastiglia. */}
        <div className="qpsc-vp-marks">
          {/* Stato muto (non-admin senza tessere dell'anno operativo):
              nessuna pastiglia, ne' vuota ne' con la classe monca. */}
          {statoSoggetto && (
            <span
              className={`qpsc-pill qpsc-vp-pill--${statoSoggetto.toLowerCase()}`}
            >
              {statoSoggetto}
            </span>
          )}

          {/* ⚠️ `isMinor` lo CALCOLA il server dalla data di nascita e lo
              scrive sul documento: qui non si deduce nulla dal `dob`, si
              legge il campo. Un documento vecchio che non lo porta
              semplicemente non mostra l'etichetta — meglio nessuna
              etichetta di un'etichetta indovinata. */}
          {user.isMinor === true && (
            <span className="qpsc-pill qpsc-vp-pill--minor">Minor</span>
          )}

          {/* §2: la pastiglia TACE se la categoria non e' nota — nessun
              timbro «NO CATEGORY» sulla scheda di una persona. */}
          <PastigliaCategoriaSeNota category={categoria} />
        </div>
      </header>

      {/* ============================================================
          1a — CORE
          ============================================================ */}
      <Sezione chiave="core" titolo="Core" {...propsSezione}>
        <div className="qpsc-vp-fields">
          <Campo etichetta="First Name" valore={user.firstName} />
          <Campo etichetta="Middle Name" valore={user.middleName} />
          <Campo etichetta="Last Name" valore={user.lastName} />

          {/* Delta 11: l'ETA' accanto alla data. Se la data non e' leggibile
              resta la sola data. */}
          <Campo
            etichetta="Date of Birth"
            valore={
              user.dob
                ? eta === null
                  ? user.dob
                  : `${user.dob} (${eta})`
                : ""
            }
          />

          {/* ⚠️ `cityOfBirth` NON si mostra piu' (delta 11): il paese basta,
              ed e' una rimozione decisa, non una dimenticanza. Il campo
              resta sul documento e nel modulo di modifica. */}
          <Campo etichetta="Country of Birth" valore={user.countryOfBirth} />
          <Campo etichetta="Nationality" valore={user.nationality} />
          {/* ⚠️ VP2/F4a: la parola, non la lettera. Vedi `genereEsteso`. */}
          <Campo etichetta="Gender" valore={genereEsteso} />

          {/* ⚠️ Per un MINORE guardato da un COACH questi due campi non
              arrivano affatto: la fase 2 li taglia sul server (delta 2), e
              al coach del bambino arriva il contatto del tutore, qui sotto,
              in Emergency. Il trattino non e' un dato mancante, e' un dato
              che non gli spetta. */}
          <Campo etichetta="Email" valore={user.email} />
          <Campo etichetta="Phone" valore={user.phone} />

          <Campo etichetta="Street" valore={user.street} />
          <Campo etichetta="Suburb" valore={user.suburb} />
          <Campo etichetta="State" valore={user.state} />
          <Campo etichetta="Postcode" valore={user.postcode} />
        </div>

        {/* ⚠️ LETTURA TOLLERANTE `mobile || phone`, ed e' una correzione, non
            un vezzo (difetto L1). Il costruttore del documento v2 scrive il
            numero d'emergenza come `phone`, mentre la ricomposizione del PUT
            — e tutto il frontend — usa `mobile`: un documento nato e mai
            passato per un salvataggio porta la grafia vecchia, e questa
            scheda mostrava «-» al posto del numero da chiamare in emergenza,
            anche per un minore.
            La regola di lettura e' UNA SOLA in tutto il frontend: la stessa
            di EditMemberModal.jsx e di `contattoDalDocumento` in
            HomeIncomplete.jsx.
            ⚠️ `emergency` non si taglia MAI, a nessuno, su nessuna rotta: e'
            il motivo per cui il ramo COACH esiste sul server. */}
        <div className="qpsc-vp-blocks">
          <div className="qpsc-vp-block">
            <span className="qpsc-vp-subhead">Primary</span>
            <div className="qpsc-vp-fields">
              <Campo etichetta="Name" valore={user.emergency?.main?.name} />
              <Campo
                etichetta="Mobile"
                valore={user.emergency?.main?.mobile || user.emergency?.main?.phone}
              />
              <Campo etichetta="Email" valore={user.emergency?.main?.email} />
            </div>
          </div>

          <div className="qpsc-vp-block">
            <span className="qpsc-vp-subhead">Secondary</span>
            <div className="qpsc-vp-fields">
              <Campo etichetta="Name" valore={user.emergency?.secondary?.name} />
              <Campo
                etichetta="Mobile"
                valore={
                  user.emergency?.secondary?.mobile ||
                  user.emergency?.secondary?.phone
                }
              />
              <Campo etichetta="Email" valore={user.emergency?.secondary?.email} />
            </div>
          </div>
        </div>

        {/* LA FOTO come FILE: il ritratto sta in testata, qui c'e' il file —
            si apre col nome, e si sostituisce se chi guarda puo'. */}
        <div className="qpsc-vp-fields">
          <Campo etichetta="Profile Photo">
            {localUser.photoUrl ? (
              <button
                type="button"
                className="qpsc-ghost-btn qpsc-vp-btn--file"
                onClick={downloadPhoto}
              >
                {nomeFileFoto}
              </button>
            ) : (
              <span className="qpsc-vp-field__value--empty">Not uploaded</span>
            )}
          </Campo>
        </div>

        {puoCambiareFoto && !showCamera && (
          <div className="qpsc-vp-actions">
            <button
              type="button"
              className="qpsc-tool-btn"
              onClick={() => setShowCamera(true)}
            >
              Take a photo
            </button>
          </div>
        )}

        {showCamera && (
          <div className="qpsc-vp-camera">
            {/* La larghezza la decide il CSS (100% della card), non un
                attributo `width` fisso: a 324px utili 320px non lascerebbero
                scampo. */}
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={{ facingMode: "user" }}
              className="qpsc-vp-camera__view"
            />

            <div className="qpsc-vp-actions">
              <button
                type="button"
                className="qpsc-tool-btn"
                onClick={handleCaptureSelfie}
                disabled={uploadingSelfie}
              >
                {uploadingSelfie ? "Uploading…" : "Capture"}
              </button>

              <button
                type="button"
                className="qpsc-ghost-btn"
                onClick={() => setShowCamera(false)}
                disabled={uploadingSelfie}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </Sezione>

      {/* ============================================================
          1b — IDENTITY DOCUMENTS
          ⚠️ AL COACH LA SEZIONE NON SI DISEGNA AFFATTO (decisione del
          committente, 22/8/2026): non vuota — ASSENTE.
          Il dato gli e' gia' tagliato dal server (`delete risposta.idDocument`
          / `.otherDocument` nel ramo coach di GET /users/:id), quindi qui non
          si nasconde nulla di sensibile: si toglie una vista che diceva il
          FALSO. Con i campi tagliati la sezione stampava «Not uploaded» anche
          su un tesserato che i documenti li ha caricati — cioe' il taglio del
          server letto da una vista incapace di distinguere «assente» da «non
          ti spetta». Non e' un dato in meno per il coach: e' una frase
          sbagliata in meno.
          Per tutti gli altri punti di vista la sezione resta identica:
          l'admin la vede e la modifica, il socio e il tutore la vedono in
          sola lettura.
          ============================================================ */}
      {!vistaCoach && (
      <Sezione chiave="documents" titolo="Identity Documents" {...propsSezione}>
        <div className="qpsc-vp-fields">
          <Campo etichetta="ID Document">
            {user.idDocument?.url ? (
              <button
                type="button"
                className="qpsc-ghost-btn qpsc-vp-btn--file"
                onClick={() =>
                  downloadDocument("id-document", user.idDocument.url.split("/").pop())
                }
              >
                {user.idDocument.url.split("/").pop()}
              </button>
            ) : (
              <span className="qpsc-vp-field__value--empty">Not uploaded</span>
            )}
          </Campo>

          <Campo etichetta="Other Document">
            {user.otherDocument?.url ? (
              <button
                type="button"
                className="qpsc-ghost-btn qpsc-vp-btn--file"
                onClick={() =>
                  downloadDocument(
                    "other-document",
                    user.otherDocument.url.split("/").pop()
                  )
                }
              >
                {user.otherDocument.url.split("/").pop()}
              </button>
            ) : (
              <span className="qpsc-vp-field__value--empty">Not uploaded</span>
            )}
          </Campo>
        </div>
      </Sezione>
      )}

      {/* ============================================================
          2 — INCLUSION & WELLBEING
          ⚠️ AL GENITORE E BASTA LA SEZIONE NON SI DISEGNA AFFATTO (addendum
          B, P2): non vuota — ASSENTE, come gia' si fa piu' sopra col coach.
          Vedi `soloGenitore` per il metro e la ragione.
          ============================================================ */}
      {!soloGenitore && (
      <Sezione chiave="wellbeing" titolo="Inclusion & Wellbeing" {...propsSezione}>
        <div className="qpsc-vp-fields">
          {/* Lingua di casa e scuola: il server li chiede ai soli minori
              (CAMPI_ENROLLED_MINORE), ma il campo esiste su ogni documento e
              su un adulto resta semplicemente vuoto. */}
          <Campo etichetta="Language at Home" valore={user.languageAtHome} />
          <Campo etichetta="School" valore={user.school} />

          {/* Tre risposte, non due: vedi `testoDisabilita`. Il dettaglio si
              mostra solo dove ha senso, cioe' quando la risposta e' si'. */}
          <Campo etichetta="Disability" valore={testoDisabilita} />

          {disabilita.has === true && (
            <Campo etichetta="Disability Details" valore={disabilita.details} />
          )}
        </div>
      </Sezione>
      )}

      {/* ============================================================
          3 — FAMILY & GUARDIANS
          I due versi del legame: i figli di un genitore e i tutori di un
          minore. La card compare se c'e' almeno una delle due liste — una
          card vuota su ogni scheda del club sarebbe solo rumore.
          ============================================================ */}
      {(mostraFigli || mostraTutori) && (
        <Sezione chiave="family" titolo="Family & Guardians" {...propsSezione}>
          {mostraFigli && (
            <div className="qpsc-vp-block">
              <span className="qpsc-vp-subhead">Children</span>

              {/* Nome sopra, ruolo sotto (tavola approvata + incarico 4b
                  punto 7): il trattino lungo del §3.3 univa due voci su UNA
                  riga, qui le righe sono due e il separatore non serve
                  piu'. */}
              <ul className="qpsc-vp-list">
                {linkedProfiles.map(figlio => (
                  <li key={figlio.id} className="qpsc-vp-row">
                    {figlio.profile ? (
                      <>
                        <span className="qpsc-vp-row__who">
                          <span className="qpsc-vp-row__name">
                            {[figlio.profile.firstName, figlio.profile.lastName]
                              .filter(Boolean)
                              .join(" ")}
                          </span>
                          {figlio.profile.role ? (
                            <span className="qpsc-vp-row__sub">
                              {figlio.profile.role}
                            </span>
                          ) : null}
                        </span>

                        {/* ⚠️ NON APRE UNA SECONDA SCHEDA SOPRA QUESTA (fase 3):
                            NAVIGA alla scheda del figlio, che e' una pagina con
                            un indirizzo suo. Il «Back» della banda riporta qui, e
                            la pila puo' scendere quanto vuole senza impilare
                            finestre. §5.4: il pulsante di consultazione. */}
                        <button
                          type="button"
                          className="qpsc-profile-btn"
                          onClick={() => navigate(`/profile/${figlio.id}`)}
                        >
                          View Profile
                        </button>
                      </>
                    ) : (
                      // Lettura rifiutata (403, o documento non piu' esistente).
                      // Riga di ripiego gemella di quella dei tutori: si dice che
                      // il legame c'e' — e' un dato del documento aperto — senza
                      // pretendere di mostrare la persona e senza offrire un
                      // pulsante che aprirebbe una scheda non disponibile.
                      <span className="qpsc-vp-row__sub">
                        Child on file — profile not available
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {mostraTutori && (
            <div className="qpsc-vp-block">
              <span className="qpsc-vp-subhead">Parents / Guardians</span>

              <ul className="qpsc-vp-list">
                {guardianProfiles.map(tutore => (
                  <li key={tutore.id} className="qpsc-vp-row">
                    {tutore.profile ? (
                      <>
                        <span className="qpsc-vp-row__who">
                          <span className="qpsc-vp-row__name">
                            {[tutore.profile.firstName, tutore.profile.lastName]
                              .filter(Boolean)
                              .join(" ")}
                          </span>
                          {tutore.profile.role ? (
                            <span className="qpsc-vp-row__sub">
                              {tutore.profile.role}
                            </span>
                          ) : null}
                        </span>

                        <button
                          type="button"
                          className="qpsc-profile-btn"
                          onClick={() => navigate(`/profile/${tutore.id}`)}
                        >
                          View Profile
                        </button>
                      </>
                    ) : (
                      // Lettura rifiutata (di norma 403: chi guarda non ha il
                      // permesso di leggere quel genitore — il caso normale
                      // per un COACH). Si dice che il tutore c'e' — il legame
                      // e' un dato del figlio — senza pretendere di mostrarlo
                      // e senza offrire un pulsante che aprirebbe una scheda
                      // non disponibile.
                      <span className="qpsc-vp-row__sub">
                        Guardian on file — profile not available
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Sezione>
      )}

      {/* ============================================================
          4 — MEMBERSHIP (era «Active Roles»)
          ⚠️ NON SI DISEGNA AL COACH (delta dell'incarico di fase 4a): e' un
          dato ORGANIZZATIVO, non sensibile, e il §11.4 consente di
          nasconderlo a schermo. Il documento continua ad arrivargli intero:
          qui non si protegge nulla, si smette di mostrare rumore.
          ⚠️ VP2/F2: non piu' i soli ruoli ATTIVI, ma TUTTE le tessere
          dell'anno operativo, ciascuna col suo stato (in attesa, attivo,
          archiviato), piu' le cariche amministrative. Il titolo non dice piu'
          «Active»: direbbe il falso.
          ============================================================ */}
      {/* ⚠️ VP2/F2: LA CARD SI DISEGNA ANCHE QUANDO NON C'E' NULLA DA
          MOSTRARE. «Nessuna tessera quest'anno» e' un fatto — un socio di
          ritorno, uno che non ha ancora rinnovato — e finora la sezione
          semplicemente spariva: chi guardava non poteva distinguere «non ha
          ruoli» da «questa scheda non li mostra». Al COACH resta nascosta,
          come prima. */}
      {!vistaCoach && (
        <Sezione
          chiave="roles"
          /* TESTO PROVVISORIO — doc 07 §11 */
          titolo={`Membership ${annoOperativo}`}
          {...propsSezione}
        >
          {contestiAttivi.length === 0 ? (
            <p className="qpsc-note">
              {/* TESTO PROVVISORIO — doc 07 §11 */}
              {`No membership for ${annoOperativo}.`}
            </p>
          ) : (
          <div className="qpsc-vp-blocks">
            {contestiAttivi.map((ctx, index) => {
              // LA SQUADRA DELLA TESSERA, dalla coppia canonica.
              //
              // ⚠️ NON C'E' PIU' UNA RIGA «Approved Teams» a parte, e non e'
              // una sottrazione: era la stessa cosa detta due volte in due
              // posti, ed era accesa dalla spia `ctx.team === "TEAMTD"` — cioe'
              // dal campo vecchio, che sulle tessere nuove non porta piu' la
              // spia e teneva quindi l'elenco NASCOSTO proprio ai coach nati
              // dopo la migrazione. Le squadre stanno ora tutte nel campo
              // «Team», che le legge da `{teams, allTeams}` con il ripiego di
              // regola B per le tessere non ancora riscritte.
              //
              // ⚠️ «All teams» E' LA SENTINELLA RESA IN INGLESE: la voce
              // letterale «ALL» non compare mai a schermo, e nemmeno «TEAMTD».
              const { teams, allTeams } = squadreDellaTessera(ctx);

              return (
                <div key={index} className="qpsc-vp-block">
                  <div className="qpsc-vp-fields">
                    {/* ⚠️ D-ADMIN1 (RD-158 residuo): il ruolo LEGGIBILE, non
                        il grezzo («Manager»). È la resa di User List e Team
                        Assignment (`roleLabel(canonicalRole(...))`), copiata:
                        la tabella delle etichette resta in auth/access.js. */}
                    <Campo
                      etichetta="Role"
                      valore={roleLabel(canonicalRole(ctx.role))}
                    />
                    <Campo etichetta="Team">
                      {allTeams ? (
                        "All teams"
                      ) : teams.length > 1 ? (
                        // Piu' squadre: l'elenco, con la stessa classe che la
                        // scheda usava gia' per le squadre approvate.
                        <ul className="qpsc-vp-list">
                          {teams.map((team, i) => (
                            <li key={i}>{team}</li>
                          ))}
                        </ul>
                      ) : (
                        // Nessuna squadra non e' un vuoto da riempire: e' una
                        // tessera di CLUB (admin, parent), e lo dice.
                        // ⚠️ D-ADMIN1 (RD-158 residuo): MA NON SU UNA TESSERA
                        // PLAYER/COACH, che una squadra la prende e oggi non ce
                        // l'ha — lì «Club Level» diceva il falso. Si scrive ciò
                        // che scrive User List per la stessa tessera: «no team».
                        teams[0] ||
                        (["PLAYER", "COACH"].includes(canonicalRole(ctx.role))
                          ? "No team"
                          : "Club Level")
                      )}
                    </Campo>
                    {/* ⚠️ NON C'E' PIU' UNA RIGA «Context» (addendum B, P1):
                        stampava `ctx.contextType`, cioe' il NOME INTERNO
                        nostro (PLAYER_CONTEXT, COACH_CONTEXT…), che a chi
                        legge non dice nulla; e su chi ha due tessere si
                        leggeva due volte. Il campo resta nel dato — qui cade
                        la sola resa. Ruolo e stato restano. */}
                    <Campo etichetta="Status" valore={statoLeggibile(ctx.status)} />
                  </div>
                </div>
              );
            })}
          </div>
          )}
        </Sezione>
      )}

      {/* ============================================================
          5a — REGISTRATION & MEMBERSHIP
          ============================================================ */}
      <Sezione
        chiave="registration"
        titolo="Registration & Membership"
        {...propsSezione}
      >
        <div className="qpsc-vp-fields">
          <Campo etichetta="FFA Number" valore={user.ffaNumber} />

          {/* IL RUOLO STA QUI, non piu' in testata (doc 07 §11.2). */}
          {/* D-ADMIN1 (RD-158 residuo): leggibile, come la riga della tessera. */}
          <Campo etichetta="Role" valore={roleLabel(canonicalRole(user.role))} />

          {/* LA SQUADRA DELL'ANNO OPERATIVO, non piu' il campo di persona
              `user.team`. Su un giocatore assegnato da Team Assignment quel
              campo e' vuoto — la squadra sta sulla TESSERA — e questa riga
              diceva «—» a chi una squadra ce l'ha. Stessa resa della card
              «Active Roles»: elenco se sono piu' d'una, «All teams» per la
              sentinella.
              ⚠️ L'elenco passa da `children`, il caso singolo da `valore`: e'
              `valore` a portare il trattino e la classe del campo VUOTO, e
              scrivere «—» a mano dentro `children` la perderebbe. */}
          {squadreDelSoggetto.nomi.length > 1 ? (
            <Campo etichetta="Team">
              <ul className="qpsc-vp-list">
                {squadreDelSoggetto.nomi.map((team, i) => (
                  <li key={i}>{team}</li>
                ))}
              </ul>
            </Campo>
          ) : (
            <Campo
              etichetta="Team"
              valore={
                squadreDelSoggetto.tutte
                  ? "All teams"
                  : squadreDelSoggetto.nomi[0] || ""
              }
            />
          )}
          {/* ⚠️ LA RIGA «Season» NON C'E' PIU' (VP2/F2, decisione 6 del
              committente). Mostrava `user.season`, un campo di PERSONA che
              porta UN anno solo, stampato accanto a dati che sono tutti
              dell'anno operativo: due annate diverse nella stessa card, senza
              nulla che lo dicesse. L'anno di questa scheda ora sta in
              testata, ed e' uno. Il campo resta sul documento: qui si smette
              di mostrarlo, non si tocca il dato. */}

          {/* Il marcatore del server, in chiaro: e' l'unica via perche' un
              amministratore sappia quali schede l'app considera incomplete —
              quelle che al login vengono dirottate su /home/incomplete. */}
          <Campo
            etichetta="Enrolment"
            valore={schedaCompleta ? "Profile complete" : "Profile incomplete"}
          />

          {/* Delta 11: `registered` non era reso da nessuna vista, pur
              arrivando col documento. E' un booleano, quindi si dichiara
              sempre — un «No» qui e' un'informazione, non un vuoto.
              ⚠️ VP2/F3: il valore e' quello dell'ANNO OPERATIVO, e la riga
              c'e' SOLO per chi e' idoneo (giocatori e allenatori). Su un
              genitore la riga non compare affatto: non e' un dato mancante,
              e' una domanda che non lo riguarda. */}
          {idoneoPlayFootball && (
            <Campo
              etichetta="Registered with Play Football"
              valore={vocePlayFootball?.registered ? "Yes" : "No"}
            />
          )}

          {/* Richiesta ancora aperta: sopra c'e' quel che la persona E', qui
              quel che ha CHIESTO di essere.
              ⚠️ Quando `requestedContext` e' `null` o assente non si disegna
              nulla: e' il caso normale (chi non ha spuntato «gioco/alleno
              anch'io» non ha chiesto niente) e una riga vuota sarebbe solo
              rumore su ogni scheda del club.
              ⚠️ Il COMANDO che la chiude non sta qui: sta nel gruppo 9, con
              gli altri comandi di gestione. */}
          {richiestaPendente && (
            <Campo etichetta="Pending role request" valore={etichettaRichiesta} />
          )}
        </div>
      </Sezione>

      {/* ============================================================
          5b — UNIFORMS
          §8: su mobile mai tabelle larghe — le righe diventano blocchi
          impilati. Le righe sono i capi attivi della lista dell'anno che
          spettano alla persona (`righeDivise`, gruppo 5b): a schermo la
          label, come chiave del dato l'id.
          ⚠️ AL GENITORE E BASTA LA SEZIONE NON SI DISEGNA AFFATTO (addendum
          B, P2): il filtro gli lasciava zero righe e la card stampava «No
          uniform items for this member.» su ogni scheda di genitore. Vedi
          `soloGenitore`.
          ============================================================ */}
      {!soloGenitore && (
      <Sezione chiave="uniforms" titolo="Uniforms" {...propsSezione}>
        {righeDivise.length === 0 ? (
          <p className="qpsc-note">No uniform items for this member.</p>
        ) : (
          <div className="qpsc-vp-block">
            <ul className="qpsc-vp-list">
              {righeDivise.map(capo => {
                // L'ID e' la chiave del dato — la cella `consegneOperative[id]`,
                // cioe' la fetta dell'anno operativo di `uniformsSeasons`, o il
                // piatto `uniforms` per il 2026 non battezzato (sede unica,
                // `consegneDellAnnata`); per gli otto storici e' il nome di
                // sempre: nessuna migrazione — la LABEL e' cio' che si legge.
                // Calco della cella della pagina, ripiego compreso: cella
                // assente = Not Delivered.
                const type = capo.id;
                const u = consegneOperative[type] || {};
                const stato = u.status || "not_delivered";

                return (
                  <li key={type} className="qpsc-vp-uniform">
                    <span className="qpsc-vp-uniform__type">{capo.label}</span>

                    <span
                      className={`qpsc-vp-uniform__status qpsc-vp-uniform__status--${stato}`}
                    >
                      {etichettaStato(stato)}
                    </span>

                    {/* «—» anche quando il capo NON HA TAGLIA (hasSize:
                        false): tre informazioni per riga, sempre. Una taglia
                        gia' salvata su un capo senza taglia resta nel dato e
                        non si mostra: nessuno la azzera (come nella pagina). */}
                    <span className="qpsc-vp-uniform__size">
                      {!capoHaTaglia(capo) || stato === "no" ? "—" : u.size || "—"}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </Sezione>
      )}

      {/* ============================================================
          6 — WORKING WITH CHILDREN CHECK
          Compare SOLO sulla scheda di un COACH (delta 12). Il FILE non si
          mostra piu' (delta 5): non esiste una rotta che lo serva — lo
          Storage e' chiuso in lettura e non c'e' alcun
          /users/:id/wwc-document — quindi era un nome scritto a schermo che
          non si poteva aprire.
          ============================================================ */}
      {soggettoECoach && (
        <Sezione
          chiave="wwc"
          titolo="Working with Children Check"
          {...propsSezione}
        >
          <div className="qpsc-vp-fields">
            <Campo etichetta="WWC Number" valore={wwc.number} />
            <Campo etichetta="WWC Expiry" valore={wwc.expiry} />
          </div>
        </Sezione>
      )}

      {/* ============================================================
          7 — FEES & PAYMENTS
          ⚠️ SI MOSTRA SEMPRE ALL'ADMIN/SA, anche su un documento che le quote
          non le porta affatto (RC-1): stesso criterio del gruppo 6, che dal
          delta 12 compare per il RUOLO e non per il dato. Una card con i
          segnaposto dice «di questa persona non risulta nulla», ed e'
          un'informazione; la card assente non diceva niente, e all'admin
          toglieva anche il posto dove intervenire.
          ⚠️ Agli ALTRI la sezione resta invisibile, ma non per questo `if`:
          per il TAGLIO DEL SERVER della fase 2 (`fees` esce solo per un
          ADMIN/SUPERADMIN attivo, su `GET /users/:id` e su `GET /users?uid=`).
          E' cio' che il §11.4 chiede per un dato sensibile, e non si tocca.
          ============================================================ */}
      {chiamanteEAdmin && (
        <Sezione chiave="fees" titolo="Fees & Payments" {...propsSezione}>
          <div className="qpsc-vp-fields">
            {/* ⚠️ TRE CAMPI, TRE VOLTE LA STESSA CAUTELA: senza il blocco
                `fees` non si stampa un valore di comodo. `importo(0)` dice
                «$ 0.00», che e' un fatto — «zero dollari dovuti» — mentre un
                documento senza quote non dice zero: dice niente, e a schermo
                diventa «—» (lo rende `Campo` sul valore vuoto).
                Lo stesso per lo sconto: un «No» su un documento che non porta
                il campo sarebbe un'affermazione che nessuno ha fatto.
                Delta 11: `totalDue` non era reso da nessuna vista. */}
            <Campo
              etichetta="Total Due"
              valore={quote ? importo(quote.totalDue) : ""}
            />
            <Campo
              etichetta="Special Discount"
              valore={quote ? (quote.specialDiscount ? "Yes" : "No") : ""}
            />
            <Campo etichetta="Discount Note" valore={quote?.discountNote} />

            {/* Anch'esso tagliato al coach dalla fase 2 (delta 3), e anch'esso
                mai reso finora: e' annidato in Play Football, non in `fees`,
                ma dice una cosa sola sulle quote e sta qui.
                ⚠️ La domanda e' se l'ANNATA c'e', non il valore: vedi il
                commento alla costante.
                ⚠️ VP2/F3: stessa sede per-annata e stesso cancello
                d'idoneita' della riga gemella nel gruppo 5a. Il taglio del
                dato a chi non e' amministratore resta del SERVER. */}
            {idoneoPlayFootball && (
              <Campo
                etichetta="Fee paid by club"
                valore={
                  vocePlayFootball
                    ? vocePlayFootball.feePaidByClub
                      ? "Yes"
                      : "No"
                    : ""
                }
              />
            )}
          </div>

          {/* Delta 11: lo STORICO dei pagamenti, mai reso finora.
              ⚠️ `pagamenti` regge gia' il caso senza quote: `quote?.payments`
              di un `quote` nullo non e' un array, quindi l'elenco e' vuoto e
              si legge la riga di sotto. Nessun accesso a `fees` mancante. */}
          <div className="qpsc-vp-block">
            <span className="qpsc-vp-subhead">Payments</span>

            {pagamenti.length === 0 ? (
              <p className="qpsc-note">No payments recorded.</p>
            ) : (
              <ul className="qpsc-vp-list">
                {pagamenti.map((p, i) => (
                  <li key={i} className="qpsc-vp-row">
                    <span className="qpsc-vp-row__name">{importo(p?.amount)}</span>
                    <span className="qpsc-vp-row__sub">
                      {dataBreve(p?.date) || "—"}
                      {p?.note ? ` — ${p.note}` : ""}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </Sezione>
      )}

      {/* ============================================================
          8a — RECORD
          Delta 6: questi cinque campi arrivavano col documento e NON erano
          resi a nessuno. Ora si mostrano al SOLO ADMIN/SA — per tutti gli
          altri sono metadati, cioe' rumore, e il §11.4 consente di
          nasconderli a schermo.
          ⚠️ `acceptedBy` e' il campo che porta la tutela legale su un minore:
          dice CHI ha accettato i termini (self / parent / guardian:<id>).
          ============================================================ */}
      {chiamanteEAdmin && (
        <Sezione chiave="record" titolo="Record" {...propsSezione}>
          <div className="qpsc-vp-fields">
            <Campo etichetta="Created" valore={dataBreve(user.createdAt)} />
            <Campo etichetta="Last updated" valore={dataBreve(user.updatedAt)} />
            <Campo
              etichetta="Terms accepted"
              valore={user.acceptTerms ? "Yes" : "No"}
            />
            <Campo
              etichetta="Accepted on"
              valore={dataBreve(user.acceptedTermsAt)}
            />
            <Campo etichetta="Accepted by" valore={user.acceptedBy} />
          </div>
        </Sezione>
      )}

      {/* ============================================================
          8b — CLUB NOTES (RL-11)
          Si disegna SOLO per chi vede i comandi di gestione
          (`puoVedereNote` = `chiamanteEAdmin`): a un genitore, a un
          allenatore o al membro stesso questa sezione non esiste, e nemmeno
          la lettura parte. La protezione vera resta sul backend, che
          risponde 403.
          Elenco PIANO, non una conversazione: testo, firma e data.
          «Edit» e «Delete» compaiono solo sulle note scritte da chi guarda —
          il backend rifiuta le altre con 403, anche a un altro admin.
          ============================================================ */}
      {puoVedereNote && (
        <Sezione chiave="notes" titolo="Club Notes" {...propsSezione}>
          {erroreNote && <p className="qpsc-vp-error">{erroreNote}</p>}

          <div className="qpsc-vp-block">
            <textarea
              className="qpsc-vp-textarea"
              rows={3}
              maxLength={2000}
              placeholder="Write an internal note…"
              value={nuovaNota}
              onChange={(e) => setNuovaNota(e.target.value)}
              disabled={notaInCorso}
            />

            <div className="qpsc-vp-actions">
              <button
                type="button"
                className="qpsc-tool-btn"
                onClick={aggiungiNota}
                disabled={notaInCorso || !nuovaNota.trim()}
              >
                {notaInCorso ? "Working…" : "Add note"}
              </button>
            </div>
          </div>

          {statoNote === "caricamento" && (
            <p className="qpsc-note">Loading notes…</p>
          )}

          {statoNote === "errore" && (
            <p className="qpsc-note">Notes are not available.</p>
          )}

          {statoNote === "pronte" && note.length === 0 && (
            <p className="qpsc-note">No notes yet.</p>
          )}

          {statoNote === "pronte" && note.length > 0 && (
            <ul className="qpsc-vp-list">
              {note.map((nota) => (
                <li key={nota.id} className="qpsc-vp-block">
                  {notaInModifica && notaInModifica.id === nota.id ? (
                    <>
                      <textarea
                        className="qpsc-vp-textarea"
                        rows={3}
                        maxLength={2000}
                        value={notaInModifica.text}
                        onChange={(e) =>
                          setNotaInModifica({
                            id: nota.id,
                            text: e.target.value
                          })
                        }
                        disabled={notaInCorso}
                      />

                      <div className="qpsc-vp-actions">
                        <button
                          type="button"
                          className="qpsc-ghost-btn"
                          onClick={salvaNotaModificata}
                          disabled={notaInCorso || !notaInModifica.text.trim()}
                        >
                          Save
                        </button>

                        <button
                          type="button"
                          className="qpsc-ghost-btn"
                          onClick={() => setNotaInModifica(null)}
                          disabled={notaInCorso}
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <p className="qpsc-vp-note-text">{nota.text}</p>

                      <span className="qpsc-vp-note-sign">
                        — {nota.authorName || "Unknown"}
                        {dataBreve(nota.createdAt)
                          ? `, ${dataBreve(nota.createdAt)}`
                          : ""}
                      </span>

                      {eMiaNota(nota) && (
                        <div className="qpsc-vp-actions">
                          <button
                            type="button"
                            className="qpsc-ghost-btn"
                            onClick={() =>
                              setNotaInModifica({
                                id: nota.id,
                                text: nota.text || ""
                              })
                            }
                            disabled={notaInCorso}
                          >
                            Edit
                          </button>

                          <button
                            type="button"
                            className="qpsc-ghost-btn"
                            onClick={() => cancellaNota(nota.id)}
                            disabled={notaInCorso}
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </li>
              ))}
            </ul>
          )}
        </Sezione>
      )}

      {/* ============================================================
          8c — EVALUATION
          Delta 14, come deciso dal committente il 22/8/2026: UN SOLO
          bottone, SPENTO, per ADMIN/SA e per il COACH — che finora non
          vedeva nulla, perche' il vecchio bottone stava dentro il blocco
          dei comandi admin.
          ⚠️ NESSUN ACCESSO REALE, per nessuno. La finestra
          `EvaluationSheetModal` non si apre piu' da questa pagina: le sue
          rotte non sono autenticate, scrive su un file escluso dal deploy e
          la chiamata del frontend e' mal indirizzata — non legge e non salva
          nulla. Si ricostruisce nel suo cantiere; il componente resta nel
          repository, semplicemente non lo monta piu' nessuno di qui.
          ============================================================ */}
      {(chiamanteEAdmin || vistaCoach) && (
        <Sezione chiave="evaluation" titolo="Evaluation" {...propsSezione}>
          <div className="qpsc-vp-actions">
            <button type="button" className="qpsc-tool-btn" disabled>
              Evaluation — coming soon
            </button>
          </div>
        </Sezione>
      )}

      {/* ============================================================
          9 — MANAGEMENT ACTIONS
          Comandi, non dati. Tutto dietro `chiamanteEAdmin`, come prima.
          ⚠️ I comandi VANNO A CAPO e non hanno larghezza minima rigida
          (`.qpsc-vp-actions`): e' la chiusura della riserva R2 — la vecchia
          griglia a due colonne con `min-width: 170px` faceva 352px
          incomprimibili in una colonna che a 360px di schermo ne misura 324,
          e la pagina scorreva di lato.
          ============================================================ */}
      {chiamanteEAdmin && (
        <Sezione chiave="management" titolo="Management Actions" {...propsSezione}>
          <div className="qpsc-vp-actions">
            {/* ⚠️ NON APRE PIU' UNA FINESTRA: ci si NAVIGA (cantiere «Edit
                Member», fase 1). La modifica e' una pagina con un indirizzo
                suo, `/profile/:id/edit`, e il suo «Back» riporta qui. E'
                l'unica riga di logica che cambia da questa parte — la stessa
                trasformazione che la fase 3 di View Profile fece ai cinque
                punti che aprivano questa scheda. */}
            <button
              type="button"
              className="qpsc-tool-btn"
              onClick={() => navigate(`/profile/${idProfilo}/edit`)}
            >
              Edit Member
            </button>

            {/* ⚠️ SOLO SE L'AZIONE PUO' RIUSCIRE. `DELETE /users/:id`
                pretende autorita' STRETTAMENTE maggiore su chi si cancella
                (server.js): un admin non cancella né sé stesso, né
                un altro admin, né il superadmin — in tutti e tre i casi
                riceve 403. Mostrare il bottone sarebbe offrire una porta
                murata.
                ⚠️ Vale per il SOLO Delete: «Edit Member» resta anche sulla
                propria scheda, ed e' voluto — l'admin modifica i propri dati
                (decisione del 22/8/2026, a diario).
                §5.1: e' la variante d'accento, UNA sola per pagina, e tocca
                all'unica azione irreversibile della scheda. */}
            {puoCancellare && (
              <button
                type="button"
                className="qpsc-tool-btn qpsc-vp-btn--accent"
                onClick={handleDelete}
              >
                Delete Member
              </button>
            )}

            {/* Il comando che CHIUDE la richiesta letta nel gruppo 5a. Sta
                qui perche' e' un comando di gestione, non un dato. */}
            {richiestaPendente && (
              <button
                type="button"
                className="qpsc-ghost-btn"
                onClick={handleArchiviaRichiesta}
                disabled={archiviandoRichiesta}
              >
                {archiviandoRichiesta ? "Working…" : "Mark request as handled"}
              </button>
            )}

            {/* Cantiere ADMIN-SA (26/9/2026): i due bottoni di famiglia sono
                di ADMIN e SUPERADMIN (prima del solo SUPERADMIN), come le
                rotte che chiamano: link-child e register-child.
                RD-164(c): `canonicalRole`, lo stesso metro della lettura dei
                giocatori per la tendina (sopra): un `role` con spazi non
                separa piu' i bottoni dalla loro tendina. */}
            {chiamanteEAdmin &&
              canonicalRole(user.role) === "PARENT" && (
                <>
                  <button
                    type="button"
                    className="qpsc-ghost-btn"
                    onClick={() => setShowLinkPlayer(true)}
                  >
                    Link Existing Player
                  </button>

                  <button
                    type="button"
                    className="qpsc-ghost-btn"
                    onClick={() => setShowCreateChild(true)}
                  >
                    Create &amp; Link Child
                  </button>

                  {/* «Renew children» (cantiere RINNOVO-FIGLI-ADMIN): rinnova
                      i figli rimasti indietro, MAI il genitore. Compare quando
                      la scheda PARENT ha dei figli collegati; se nessuno ha
                      titolo, la finestra lo dice invece di sparire — un
                      pulsante che c'e' a volte si e a volte no, senza
                      spiegazione, sorprende piu' di una riga che dice
                      «nothing to renew». */}
                  {Array.isArray(user.linkedProfiles) &&
                    user.linkedProfiles.length > 0 && (
                      <button
                        type="button"
                        className="qpsc-ghost-btn"
                        onClick={apriRinnovoFigli}
                      >
                        Renew children
                      </button>
                    )}
                </>
              )}

            {/* «Send sign-in link» (cantiere LINK-ACCESSO, F2): SOLO
                SUPERADMIN (`chiamanteESuperAdmin`), per OGNI scheda non
                minore — quindi fuori dal frammento PARENT. Dal cantiere
                ADMIN-SA (26/9/2026) NON ha piu' lo stesso gate dei due
                bottoni di famiglia, che sono anche dell'ADMIN.
                Sui minori non si disegna (`eMinoreQuestaScheda`): un minore
                non ha un login proprio, e il backend risponderebbe 400 —
                mostrare il bottone sarebbe offrire una porta murata. §5.3:
                fantasma, e' un'azione di servizio. */}
            {chiamanteESuperAdmin && !eMinoreQuestaScheda && (
              <button
                type="button"
                className="qpsc-ghost-btn"
                onClick={handleSendSigninLink}
                disabled={inviandoLink}
              >
                {inviandoLink ? "Sending…" : "Send sign-in link"}
              </button>
            )}
          </div>
        </Sezione>
      )}

      {/* ============================================================
          LE FINESTRE FIGLIE (doc 07 §11.1: le finestre di servizio aperte DA
          questa pagina restano finestre). Il loro contenuto NON e' materia
          di questa fase: markup e classi restano quelli di prima.
          ============================================================ */}
      {/* «Renew children» — la finestra (cantiere RINNOVO-FIGLI-ADMIN).
          Classi `qpsc-modal` / `qpsc-check` di AdminTools.css, gia' importato:
          nessun foglio nuovo. */}
      {showRenewChildren && (
        <div className="qpsc-modal-overlay">
          <div
            className="qpsc-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="qpsc-renew-children-title"
          >
            <h2 className="qpsc-modal__title" id="qpsc-renew-children-title">
              {Number.isInteger(enrollmentSeason)
                ? `Renew children for ${enrollmentSeason}`
                : "Renew children"}
            </h2>

            <div className="qpsc-modal__body">
              {esitoRinnovo && esitoRinnovo.tipo !== "errore" ? (
                // RISCONTRO: la lista sparisce, l'esito resta da leggere.
                <>
                  <p className="qpsc-modal__note">{esitoRinnovo.testo}</p>
                  {esitoRinnovo.nonInclusi && (
                    <p className="qpsc-modal__note">{esitoRinnovo.nonInclusi}</p>
                  )}
                </>
              ) : !Number.isInteger(enrollmentSeason) ? (
                <p className="qpsc-modal__note">
                  The enrollment season could not be read. Please try again in a moment.
                </p>
              ) : enrollmentsOpen === false ? (
                <p className="qpsc-modal__note">
                  Enrollments are currently closed.
                </p>
              ) : titoliRinnovo.stato === "caricamento" ? (
                <p className="qpsc-modal__note">Loading&hellip;</p>
              ) : titoliRinnovo.stato === "errore" ? (
                <p className="qpsc-modal__note">
                  The children&rsquo;s details could not be loaded. Please try again in a moment.
                </p>
              ) : figliDaRinnovare.length === 0 ? (
                <p className="qpsc-modal__note">
                  Nothing to renew: no child of this member can be enrolled
                  for {enrollmentSeason} from here.
                </p>
              ) : (
                <>
                  {figliDaRinnovare.map(figlio => (
                    <label className="qpsc-check" key={figlio.id}>
                      <input
                        className="qpsc-check__input"
                        type="checkbox"
                        checked={sceltiRinnovo.includes(figlio.id)}
                        onChange={() => spuntaRinnovo(figlio.id)}
                        disabled={invioRinnovo}
                      />
                      <span className="qpsc-check__box" aria-hidden="true" />
                      <span>{figlio.nome || "A child's record"}</span>
                    </label>
                  ))}

                  <p className="qpsc-modal__note">
                    This member&rsquo;s own membership is not renewed here.
                    Each child starts as a request: approve it from Team
                    Assignment as usual.
                  </p>

                  {esitoRinnovo && esitoRinnovo.tipo === "errore" && (
                    <p className="qpsc-modal__note">{esitoRinnovo.testo}</p>
                  )}
                </>
              )}
            </div>

            <div className="qpsc-modal__actions">
              {!(esitoRinnovo && esitoRinnovo.tipo !== "errore") &&
                Number.isInteger(enrollmentSeason) &&
                enrollmentsOpen !== false &&
                figliDaRinnovare.length > 0 && (
                  <button
                    type="button"
                    className="qpsc-tool-btn"
                    onClick={confermaRinnovoFigli}
                    disabled={
                      invioRinnovo ||
                      !sceltiRinnovo.some(id =>
                        figliDaRinnovare.some(figlio => figlio.id === id)
                      )
                    }
                  >
                    {invioRinnovo ? "Sending…" : "Confirm"}
                  </button>
                )}
              <button
                type="button"
                className="qpsc-ghost-btn"
                onClick={chiudiRinnovoFigli}
                disabled={invioRinnovo}
              >
                {esitoRinnovo && esitoRinnovo.tipo !== "errore" ? "Close" : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showLinkPlayer && (
        <div className="modal-overlay">
          <div className="modal">

            <h3>Link Existing Player</h3>

            <select
              value={selectedPlayerId}
              onChange={(e) => setSelectedPlayerId(e.target.value)}
              style={{ width: "100%", marginBottom: "15px" }}
            >
              <option value="">Select Player</option>

              {allPlayers.map(player => (
                <option key={player.id} value={player.id}>
                  {player.firstName} {player.lastName}
                </option>
              ))}
            </select>

            <div className="modal-actions">

              <button
                className="profile-action-btn gold-btn"
                onClick={async () => {

                  if (!selectedPlayerId) return;

                  const existing =
                    Array.isArray(user.linkedProfiles)
                      ? user.linkedProfiles
                      : [];

                  const alreadyLinked = existing.some(
                    lp => String(lp.profileId) === String(selectedPlayerId)
                  );

                  if (alreadyLinked) {
                    alert("Player already linked.");
                    return;
                  }

                  try {

                    // Il legame lo scrive la rotta dedicata, non un PUT sul
                    // solo genitore: il PUT scriveva `linkedProfiles` e
                    // basta, lasciando vuoti i `guardians` del figlio — cioe'
                    // il verso autorevole del legame. La rotta scrive le due
                    // facce insieme e ricompone lei l'elenco.
                    await api.post(`/users/${user.id}/link-child`, {
                      childId: selectedPlayerId
                    });

                    alert("Player linked successfully.");

                    setShowLinkPlayer(false);

                    // La scheda si rilegge: la risposta del PUT porta i soli
                    // campi scritti, non il documento da disegnare.
                    await ricaricaProfilo();

                    propagaAggiornamento();

                  } catch (err) {
                    console.error(err);
                    alert("Failed to link player.");
                  }
                }}
              >
                Link
              </button>

              <button
                className="profile-action-btn red-btn"
                onClick={() => setShowLinkPlayer(false)}
              >
                Cancel
              </button>

            </div>
          </div>
        </div>
      )}

      {showCreateChild && (
        <div className="modal-overlay">
          <div className="modal">

            <h3>Create &amp; Link Child</h3>

            <input
              type="text"
              placeholder="First Name"
              value={newChild.firstName}
              onChange={(e) =>
                setNewChild({
                  ...newChild,
                  firstName: e.target.value
                })
              }
            />

            <input
              type="text"
              placeholder="Last Name"
              value={newChild.lastName}
              onChange={(e) =>
                setNewChild({
                  ...newChild,
                  lastName: e.target.value
                })
              }
            />

            <input
              type="date"
              value={newChild.dob}
              onChange={(e) =>
                setNewChild({
                  ...newChild,
                  dob: e.target.value
                })
              }
            />

            <select
              value={newChild.gender}
              onChange={(e) =>
                setNewChild({
                  ...newChild,
                  gender: e.target.value
                })
              }
            >
              {/* ⚠️ VP2/F4b: le opzioni vengono dal vocabolario unico
                  `GENERI` — valore la lettera, testo la parola — invece di
                  essere scritte a mano qui. Cosi' questa tendina non puo'
                  piu' divergere da quelle dei moduli d'iscrizione. */}
              {GENERI.map((g) => (
                <option key={g.valore} value={g.valore}>
                  {g.etichetta}
                </option>
              ))}
            </select>

            <input
              type="email"
              placeholder="Email"
              value={newChild.email}
              onChange={(e) =>
                setNewChild({
                  ...newChild,
                  email: e.target.value
                })
              }
            />

            <input
              type="text"
              placeholder="Phone"
              value={newChild.phone}
              onChange={(e) =>
                setNewChild({
                  ...newChild,
                  phone: e.target.value
                })
              }
            />

            <div className="modal-actions">

              <button
                className="profile-action-btn gold-btn"
                onClick={async () => {

                  if (
                    !newChild.firstName.trim() ||
                    !newChild.lastName.trim()
                  ) {
                    alert("First Name and Last Name required");
                    return;
                  }

                  try {

                    await api.post("/register-child", {
                      parentUid: user.id,
                      firstName: newChild.firstName,
                      lastName: newChild.lastName,
                      dob: newChild.dob,
                      gender: newChild.gender,
                      email: newChild.email,
                      phone: newChild.phone
                    });

                    alert("Child created and linked.");

                    setShowCreateChild(false);

                    setNewChild({
                      firstName: "",
                      lastName: "",
                      dob: "",
                      gender: GENERI[0].valore,
                      email: "",
                      phone: ""
                    });

                    // La scheda si rilegge: la risposta di /register-child e'
                    // il documento del FIGLIO, mentre qui si mostra il
                    // genitore — che il backend ha aggiornato per conto suo
                    // con il nuovo profilo collegato.
                    await ricaricaProfilo();

                    propagaAggiornamento();

                  } catch (err) {
                    console.error(err);
                    alert("Failed creating child");
                  }
                }}
              >
                Create Child
              </button>

              <button
                className="profile-action-btn red-btn"
                onClick={() => setShowCreateChild(false)}
              >
                Cancel
              </button>

            </div>

          </div>
        </div>
      )}

      {/* ⚠️ QUI STAVA IL MONTAGGIO DI `EditMemberModal`, e non c'e' piu':
          la modifica e' una PAGINA (`/profile/:id/edit`), e il pulsante del
          gruppo 9 ci naviga. Il ridisegno della scheda dopo un salvataggio
          non serve piu' passarlo di qui: tornando col «Back» questa pagina si
          rimonta e rilegge il documento da se'. L'unico effetto che il
          ritorno non produrrebbe — riscrivere l'utente collegato quando si
          modifica la PROPRIA scheda — lo fa ora la pagina della modifica,
          dalla stessa sede unica (`refreshUserFromBackend`). */}
    </HomeShell>
  );
};

export default MemberProfileModal;
